(() => {
  const DEFAULT_LAT_LNG = { lat: 33.98212112750667, lng: -117.59423191249809 };
  const GOOGLE_MAPS_SRC = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDgRSctmAHoWQSBrDCg6sWY37Ijlk_QOXQ&v=weekly&libraries=places';
  // 暂时隐藏地图气泡（business-info + 关闭按钮）；后续要恢复改回 true
  const SHOW_BUSINESS_INFO_WINDOW = false;
  const receatVechiclesIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
  <path d="M19 4H21V2L19 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V11C0 11.5304 0.210714 12.0391 0.585786 12.4142C0.960859 12.7893 1.46957 13 2 13H3C3 13.7956 3.31607 14.5587 3.87868 15.1213C4.44129 15.6839 5.20435 16 6 16C6.79565 16 7.55871 15.6839 8.12132 15.1213C8.68393 14.5587 9 13.7956 9 13H14C14 13.7956 14.3161 14.5587 14.8787 15.1213C15.4413 15.6839 16.2044 16 17 16C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13H22V8M6 14.5C5.60218 14.5 5.22064 14.342 4.93934 14.0607C4.65804 13.7794 4.5 13.3978 4.5 13C4.5 12.6022 4.65804 12.2206 4.93934 11.9393C5.22064 11.658 5.60218 11.5 6 11.5C6.39782 11.5 6.77936 11.658 7.06066 11.9393C7.34196 12.2206 7.5 12.6022 7.5 13C7.5 13.3978 7.34196 13.7794 7.06066 14.0607C6.77936 14.342 6.39782 14.5 6 14.5ZM8 8H2V5H8M13 11H10V5H13M17 14.5C16.7033 14.5 16.4133 14.412 16.1666 14.2472C15.92 14.0824 15.7277 13.8481 15.6142 13.574C15.5007 13.2999 15.4709 12.9983 15.5288 12.7074C15.5867 12.4164 15.7296 12.1491 15.9393 11.9393C16.1491 11.7296 16.4164 11.5867 16.7074 11.5288C16.9983 11.4709 17.2999 11.5006 17.574 11.6142C17.8481 11.7277 18.0824 11.92 18.2472 12.1666C18.412 12.4133 18.5 12.7033 18.5 13C18.4899 13.3946 18.3286 13.7703 18.0495 14.0495C17.7703 14.3286 17.3946 14.4899 17 14.5ZM16 8V5.5H18.5L20.5 8H16Z" fill="#747474"/>
  </svg>`
  const offGridIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M7.64929 0.850063C7.64929 0.380586 8.02988 0 8.49936 0C8.96884 0 9.34942 0.380587 9.34942 0.850064V1.70121C9.34942 2.17069 8.96884 2.55128 8.49936 2.55128C8.02988 2.55128 7.64929 2.17069 7.64929 1.70121V0.850063ZM14.4498 8.50425C14.4498 8.03458 14.8306 7.65383 15.3002 7.65383H16.1496C16.6193 7.65383 17 8.03458 17 8.50425C17 8.97393 16.6193 9.35468 16.1496 9.35468H15.3002C14.8306 9.35468 14.4498 8.97393 14.4498 8.50425ZM12.7497 9.15058V8.50425C12.7497 6.15708 10.8455 4.25213 8.49936 4.25213C6.15318 4.25213 4.24904 6.15708 4.24904 8.50425H0.848781C0.551259 8.50425 0.279238 8.65733 0.126227 8.90395C-0.0267846 9.15058 -0.0437861 9.46523 0.0922242 9.72886L3.49248 16.5323C3.56312 16.6725 3.6712 16.7905 3.80474 16.873C3.93828 16.9556 4.09206 16.9995 4.24904 17H15.2999C15.5974 17 15.8694 16.8469 16.0224 16.6003C16.1754 16.3537 16.1924 16.039 16.0564 15.7754L12.7497 9.15058ZM11.3726 10.2051L12.2226 11.906H8.81388L7.96382 10.2051H11.3726ZM6.05967 10.2051L6.90974 11.906H3.07595L2.22589 10.2051H6.05967ZM3.92601 13.6068H7.7598L8.60987 15.3077H4.77608L3.92601 13.6068ZM10.514 15.3077L9.66395 13.6068H13.0727L13.9228 15.3077H10.514ZM12.7072 3.08704C12.3738 3.42056 12.3738 3.96114 12.7072 4.29465C13.0405 4.62808 13.581 4.62808 13.9143 4.29465L14.2118 3.997L14.5093 3.69935C14.8427 3.36584 14.8427 2.82526 14.5093 2.49175C14.176 2.15832 13.6355 2.15832 13.3022 2.49175L13.0047 2.7894L12.7072 3.08704ZM2.4894 2.49175C2.15603 2.82526 2.15603 3.36584 2.4894 3.69935L2.78693 3.997L3.08445 4.29465C3.41774 4.62808 3.95825 4.62808 4.29154 4.29465C4.62491 3.96114 4.62491 3.42056 4.29154 3.08704L3.99402 2.7894L3.6965 2.49175C3.36321 2.15832 2.82269 2.15832 2.4894 2.49175Z" fill="#747474"/>
  </svg>`
  const offRoadIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
  <path d="M14.3083 5.06591C14.2807 5.04469 14.261 5.01518 14.2522 4.98192C14.2434 4.94866 14.246 4.91349 14.2596 4.88182C14.2716 4.84836 14.2944 4.81962 14.3245 4.79995C14.3546 4.78027 14.3904 4.77072 14.4266 4.77273H14.9555C15.1401 4.77273 15.3171 4.70089 15.4476 4.57303C15.5781 4.44516 15.6514 4.27174 15.6514 4.09091V2.21591C15.6514 2.03508 15.5781 1.86166 15.4476 1.73379C15.3171 1.60593 15.1401 1.53409 14.9555 1.53409H14.0856C14.0394 1.53409 13.9952 1.51613 13.9626 1.48417C13.9299 1.4522 13.9116 1.40884 13.9116 1.36364V1.02273C13.9116 0.751483 13.8016 0.491348 13.6058 0.29955C13.4101 0.107751 13.1446 0 12.8677 0H3.12472C2.84786 0 2.58234 0.107751 2.38657 0.29955C2.19081 0.491348 2.08082 0.751483 2.08082 1.02273V1.36364C2.08082 1.40884 2.06249 1.4522 2.02987 1.48417C1.99724 1.51613 1.95299 1.53409 1.90684 1.53409H1.03693C0.852361 1.53409 0.675349 1.60593 0.544837 1.73379C0.414325 1.86166 0.341005 2.03508 0.341005 2.21591V4.09091C0.341005 4.27174 0.414325 4.44516 0.544837 4.57303C0.675349 4.70089 0.852361 4.77273 1.03693 4.77273H1.56584C1.60198 4.77072 1.63782 4.78027 1.66794 4.79995C1.69807 4.81962 1.72085 4.84836 1.73286 4.88182C1.74722 4.91279 1.75091 4.94749 1.74338 4.9807C1.73585 5.01391 1.7175 5.04381 1.6911 5.06591L0.208778 6.42955C0.0750106 6.60747 0.00195005 6.82221 2.58124e-10 7.04318V10.2273C-6.12549e-06 10.4973 0.109019 10.7564 0.303284 10.9481C0.497549 11.1397 0.761283 11.2482 1.03693 11.25H1.21091C1.25706 11.25 1.30131 11.268 1.33394 11.2999C1.36657 11.3319 1.3849 11.3752 1.3849 11.4205V13.9773C1.3849 14.2485 1.49488 14.5087 1.69065 14.7004C1.88641 14.8922 2.15193 15 2.42879 15H3.82064C4.0975 15 4.36302 14.8922 4.55879 14.7004C4.75456 14.5087 4.86454 14.2485 4.86454 13.9773V11.4205C4.86454 11.3752 4.88287 11.3319 4.91549 11.2999C4.94812 11.268 4.99238 11.25 5.03852 11.25H10.9678C11.014 11.25 11.0582 11.268 11.0908 11.2999C11.1235 11.3319 11.1418 11.3752 11.1418 11.4205V13.9773C11.1418 14.2462 11.2499 14.5043 11.4426 14.6957C11.6354 14.8871 11.8973 14.9964 12.1718 15H13.5636C13.8405 15 14.106 14.8922 14.3018 14.7004C14.4975 14.5087 14.6075 14.2485 14.6075 13.9773V11.4205C14.6075 11.3752 14.6259 11.3319 14.6585 11.2999C14.6911 11.268 14.7354 11.25 14.7815 11.25H14.9555C15.2323 11.25 15.4979 11.1422 15.6936 10.9504C15.8894 10.7587 15.9994 10.4985 15.9994 10.2273V7.04318C16.0084 6.79282 15.9187 6.54866 15.7488 6.36136L14.3083 5.06591ZM5.2125 9.88636C5.12021 9.88636 5.03171 9.85045 4.96645 9.78651C4.9012 9.72258 4.86454 9.63587 4.86454 9.54545V8.86364C4.86454 8.68281 4.93786 8.50938 5.06837 8.38152C5.19888 8.25365 5.37589 8.18182 5.56046 8.18182H10.432C10.5235 8.1813 10.6143 8.1985 10.6991 8.23243C10.7839 8.26636 10.861 8.31635 10.9261 8.37955C10.9906 8.44325 11.0416 8.51881 11.0762 8.60188C11.1109 8.68495 11.1284 8.7739 11.1279 8.86364V9.54545C11.1279 9.63587 11.0912 9.72258 11.026 9.78651C10.9607 9.85045 10.8722 9.88636 10.7799 9.88636H5.2125ZM3.47268 4.43182V1.70455C3.47268 1.61413 3.50934 1.52742 3.5746 1.46349C3.63985 1.39955 3.72836 1.36364 3.82064 1.36364H7.1263C7.21859 1.36364 7.30709 1.39955 7.37235 1.46349C7.43761 1.52742 7.47427 1.61413 7.47427 1.70455V4.43182C7.47427 4.52223 7.43761 4.60894 7.37235 4.67288C7.30709 4.73681 7.21859 4.77273 7.1263 4.77273H3.82064C3.77432 4.77099 3.72882 4.76021 3.68681 4.74101C3.6448 4.72181 3.60713 4.69458 3.57601 4.66091C3.54489 4.62725 3.52095 4.58783 3.5056 4.54498C3.49024 4.50212 3.48378 4.4567 3.4866 4.41136L3.47268 4.43182ZM8.51816 4.43182V1.70455C8.51816 1.61413 8.55482 1.52742 8.62007 1.46349C8.68533 1.39955 8.77384 1.36364 8.86612 1.36364H12.1718C12.2641 1.36364 12.3526 1.39955 12.4178 1.46349C12.4831 1.52742 12.5197 1.61413 12.5197 1.70455V4.43182C12.5197 4.52223 12.4831 4.60894 12.4178 4.67288C12.3526 4.73681 12.2641 4.77273 12.1718 4.77273H8.88004C8.83253 4.77281 8.78551 4.76336 8.74188 4.74497C8.69824 4.72657 8.65891 4.69961 8.62631 4.66576C8.59371 4.6319 8.56853 4.59187 8.55232 4.54811C8.53612 4.50436 8.52923 4.45782 8.53208 4.41136L8.51816 4.43182ZM2.42879 7.84091C2.63525 7.84091 2.83708 7.90089 3.00874 8.01327C3.18041 8.12565 3.31421 8.28538 3.39322 8.47226C3.47223 8.65913 3.4929 8.86477 3.45262 9.06316C3.41234 9.26155 3.31292 9.44378 3.16693 9.58681C3.02094 9.72984 2.83494 9.82725 2.63244 9.86671C2.42995 9.90617 2.22005 9.88592 2.02931 9.80851C1.83856 9.73111 1.67553 9.60002 1.56082 9.43183C1.44612 9.26365 1.3849 9.06591 1.3849 8.86364C1.3849 8.59239 1.49488 8.33226 1.69065 8.14046C1.88641 7.94866 2.15193 7.84091 2.42879 7.84091ZM13.5636 9.88636C13.3572 9.88636 13.1553 9.82638 12.9837 9.714C12.812 9.60162 12.6782 9.4419 12.5992 9.25502C12.5202 9.06814 12.4995 8.8625 12.5398 8.66411C12.5801 8.46572 12.6795 8.28349 12.8255 8.14046C12.9715 7.99743 13.1575 7.90002 13.36 7.86056C13.5625 7.8211 13.7724 7.84135 13.9631 7.91876C14.1539 7.99617 14.3169 8.12725 14.4316 8.29544C14.5463 8.46363 14.6075 8.66136 14.6075 8.86364C14.6075 9.13488 14.4975 9.39502 14.3018 9.58681C14.106 9.77861 13.8405 9.88636 13.5636 9.88636Z" fill="#747474"/>
  </svg>`;
  const workServiceVechiclesIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
  <path d="M11.375 7.57895H1.625V3.36842H11.375M10.1562 12.6316C9.83302 12.6316 9.52302 12.4985 9.29446 12.2616C9.0659 12.0247 8.9375 11.7034 8.9375 11.3684C8.9375 11.0334 9.0659 10.7121 9.29446 10.4752C9.52302 10.2383 9.83302 10.1053 10.1562 10.1053C10.4795 10.1053 10.7895 10.2383 11.018 10.4752C11.2466 10.7121 11.375 11.0334 11.375 11.3684C11.375 11.7034 11.2466 12.0247 11.018 12.2616C10.7895 12.4985 10.4795 12.6316 10.1562 12.6316ZM2.84375 12.6316C2.52052 12.6316 2.21052 12.4985 1.98196 12.2616C1.7534 12.0247 1.625 11.7034 1.625 11.3684C1.625 11.0334 1.7534 10.7121 1.98196 10.4752C2.21052 10.2383 2.52052 10.1053 2.84375 10.1053C3.16698 10.1053 3.47698 10.2383 3.70554 10.4752C3.9341 10.7121 4.0625 11.0334 4.0625 11.3684C4.0625 11.7034 3.9341 12.0247 3.70554 12.2616C3.47698 12.4985 3.16698 12.6316 2.84375 12.6316ZM0 11.7895C0 12.5305 0.316875 13.1958 0.8125 13.6589V15.1579C0.8125 15.3812 0.898103 15.5954 1.05048 15.7534C1.20285 15.9113 1.40951 16 1.625 16H2.4375C2.65299 16 2.85965 15.9113 3.01202 15.7534C3.1644 15.5954 3.25 15.3812 3.25 15.1579V14.3158H9.75V15.1579C9.75 15.3812 9.8356 15.5954 9.98798 15.7534C10.1403 15.9113 10.347 16 10.5625 16H11.375C11.5905 16 11.7972 15.9113 11.9495 15.7534C12.1019 15.5954 12.1875 15.3812 12.1875 15.1579V13.6589C12.6831 13.1958 13 12.5305 13 11.7895V3.36842C13 0.421053 10.0912 0 6.5 0C2.90875 0 0 0.421053 0 3.36842V11.7895Z" fill="#747474"/>
  </svg>`
  const boatsMarineIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M13.7149 15.76C13.7148 15.7169 13.703 15.6746 13.6806 15.6375C13.6581 15.6005 13.6259 15.57 13.5874 15.5495C12.6205 15.0389 11.7387 14.2575 11.3508 13.8652C11.2932 13.8058 11.2163 13.768 11.1334 13.7584C11.0505 13.7487 10.9667 13.7677 10.8965 13.8122C9.09898 14.9498 6.91034 14.9505 5.11242 13.8139C5.04163 13.769 4.95705 13.7499 4.8734 13.7599C4.78975 13.7699 4.71231 13.8084 4.65455 13.8687C4.26989 14.2645 3.39772 15.0372 2.42483 15.5442C2.38615 15.5633 2.35308 15.5918 2.32876 15.627C2.30444 15.6622 2.28969 15.7029 2.2859 15.7453C2.283 15.7813 2.28857 15.8176 2.30219 15.8512C2.31581 15.8848 2.33711 15.9149 2.36444 15.9391C2.39178 15.9634 2.42442 15.9811 2.45985 15.991C2.49527 16.0009 2.53254 16.0027 2.56876 15.9961C3.31343 15.8495 4.0331 15.5161 4.71883 15.16C4.76282 15.1372 4.81172 15.1251 4.86144 15.1248C4.91115 15.1244 4.96023 15.1358 5.00456 15.1579C5.93297 15.6216 6.95976 15.8633 8.00127 15.8633C9.04278 15.8633 10.0696 15.6216 10.998 15.1579C11.0428 15.1355 11.0924 15.1241 11.1427 15.1244C11.193 15.1248 11.2424 15.137 11.2869 15.16C11.9691 15.5109 12.6877 15.8474 13.4298 15.9951C13.4649 16.0017 13.5011 16.0006 13.5356 15.9918C13.5702 15.9829 13.6023 15.9667 13.6297 15.9441C13.6571 15.9216 13.679 15.8933 13.6938 15.8614C13.7087 15.8295 13.7161 15.7947 13.7156 15.7596L13.7149 15.76ZM15.8831 7.82175C15.7585 7.52735 15.4938 7.29927 15.1367 7.17786L14.2863 6.84522V3.93C14.2863 3.3344 14.0455 2.76319 13.6168 2.34204C13.1881 1.92089 12.6067 1.68429 12.0005 1.68429H10.8576V1.40357C10.8576 1.03132 10.7071 0.674317 10.4392 0.411096C10.1713 0.147876 9.80789 0 9.429 0H6.57176C6.19286 0 5.82949 0.147876 5.56157 0.411096C5.29365 0.674317 5.14314 1.03132 5.14314 1.40357V1.68429H4.00024C3.39401 1.68429 2.81261 1.92089 2.38394 2.34204C1.95527 2.76319 1.71445 3.3344 1.71445 3.93V6.84767L0.872275 7.17716C0.517263 7.29295 0.242611 7.52805 0.116892 7.82421C0.0293894 8.03088 -0.070614 8.35055 0.0704623 8.75267L0.0740338 8.76319L1.74052 12.9543C1.80191 13.1082 1.90933 13.2403 2.04864 13.3332C2.18794 13.426 2.35259 13.4752 2.5209 13.4743C2.53876 13.4743 2.55662 13.4743 2.57555 13.4725C3.69416 13.4023 4.57562 12.8665 5.16849 12.3634C6.01531 13.0816 7.01141 13.4743 8.00038 13.4743C8.98934 13.4743 9.98009 13.0813 10.8269 12.362C11.4194 12.8658 12.302 13.4031 13.4202 13.4725C13.5972 13.4847 13.7736 13.4412 13.9237 13.3482C14.0738 13.2551 14.1898 13.1175 14.2549 12.9553L15.921 8.77969C16.0381 8.49581 16.0246 8.1565 15.8831 7.82175ZM8.46468 4.56897L8.42396 4.55494C8.14812 4.46966 7.85228 4.46966 7.57643 4.55494L7.55572 4.56125L3.05306 6.32379C3.03138 6.33227 3.00791 6.33541 2.98471 6.33292C2.96151 6.33043 2.93928 6.3224 2.91997 6.30952C2.90066 6.29664 2.88485 6.27931 2.87393 6.25904C2.86302 6.23877 2.85732 6.21619 2.85734 6.19326V3.93C2.85734 3.6322 2.97776 3.3466 3.19209 3.13602C3.40642 2.92544 3.69712 2.80714 4.00024 2.80714H12.0005C12.3036 2.80714 12.5943 2.92544 12.8087 3.13602C13.023 3.3466 13.1434 3.6322 13.1434 3.93V6.19115C13.1434 6.21408 13.1377 6.23667 13.1268 6.25694C13.1159 6.2772 13.1001 6.29454 13.0808 6.30742C13.0615 6.32029 13.0392 6.32833 13.016 6.33082C12.9928 6.3333 12.9694 6.33017 12.9477 6.32168L8.46468 4.56897Z" fill="#747474"/>
  </svg>`;
  const commercialMarineIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="12" viewBox="0 0 19 12" fill="none">
  <path d="M4.7265 9.49687L5.09403 9.78258C5.46157 10.0683 5.9121 10.2397 6.37449 10.274L6.57604 10.2854H6.6946C7.22812 10.2854 7.74979 10.114 8.17661 9.78258L8.54414 9.49687C8.84501 9.26887 9.21662 9.14492 9.59933 9.14492C9.98204 9.14492 10.3537 9.26887 10.6545 9.49687L11.0221 9.78258C11.3896 10.0683 11.8401 10.2397 12.3025 10.274L12.5041 10.2854H12.6226C13.1561 10.2854 13.6778 10.114 14.1046 9.78258L14.4722 9.49687C14.773 9.26887 15.1446 9.14492 15.5274 9.14492C15.9101 9.14492 16.2817 9.26887 16.5825 9.49687L16.9619 9.79401C17.3176 10.0683 17.7681 10.2397 18.2305 10.2854C18.2305 10.2854 18.3906 10.2707 18.4914 10.2854C19.166 10.3843 19.1731 11.977 18.4914 11.9997C18.4682 12.0004 18.4321 11.9997 18.4321 11.9997C17.8867 11.9997 17.3769 11.8168 16.9619 11.4968L16.5825 11.2111C16.2817 10.9831 15.9101 10.8592 15.5274 10.8592C15.1446 10.8592 14.773 10.9831 14.4722 11.2111L14.1046 11.4968C13.6778 11.8168 13.1561 11.9997 12.6226 11.9997H12.5041C11.9705 11.9997 11.4489 11.8168 11.0221 11.4968L10.6545 11.2111C10.3537 10.9831 9.98204 10.8592 9.59933 10.8592C9.21662 10.8592 8.84501 10.9831 8.54414 11.2111L8.17661 11.4968C7.74979 11.8168 7.22812 11.9997 6.6946 11.9997H6.57604C6.04252 11.9997 5.52085 11.8168 5.09403 11.4968L4.7265 11.2111C4.42563 10.9831 4.05402 10.8592 3.67131 10.8592C3.2886 10.8592 2.91698 10.9831 2.61612 11.2111L2.23673 11.4968C1.82177 11.8168 1.31196 11.9997 0.766578 11.9997C0.766578 11.9997 0.730435 12.0004 0.707298 11.9997C0.0255807 11.977 0.0255807 10.3081 0.707298 10.2854C0.730435 10.2846 0.766578 10.2854 0.766578 10.2854C1.31196 10.2854 1.82177 10.114 2.23673 9.79401L2.61612 9.49687C2.91698 9.26887 3.2886 9.14492 3.67131 9.14492C4.05402 9.14492 4.42563 9.26887 4.7265 9.49687ZM17.4688 5.14271C17.8849 5.14271 18.119 5.62134 17.8634 5.94975L16.713 7.42836C16.5351 7.65692 16.3454 7.87406 16.132 8.06834C15.9423 8.02263 15.7408 7.99977 15.5274 7.99977C14.8753 7.99977 14.2469 8.21691 13.7252 8.60547L13.3577 8.89117C13.1561 9.05117 12.8953 9.1426 12.6226 9.1426H12.5041C12.2314 9.1426 11.9705 9.05117 11.769 8.89117L11.3896 8.60547C10.8798 8.21691 10.2514 7.99977 9.59933 7.99977C8.94725 7.99977 8.31888 8.21691 7.80907 8.60547L7.42968 8.89117C7.22812 9.05117 6.96729 9.1426 6.6946 9.1426H6.57604C6.30335 9.1426 6.04252 9.05117 5.84096 8.89117L5.46157 8.60547C4.95176 8.21691 4.32339 7.99977 3.67131 7.99977C3.01923 7.99977 2.39086 8.21691 1.88105 8.60547L1.50165 8.89117C1.28824 9.0626 1.03927 9.1426 0.766578 9.1426C0.766578 9.1426 0.730445 9.14293 0.707298 9.1426C-0.609213 9.1238 0.252457 6.39878 0.589441 5.45787C0.658369 5.26541 0.84134 5.14271 1.04577 5.14271H17.4688ZM12.6582 0C12.9309 0 13.7371 0.0799978 14.0809 0.788549L15.7227 3.83403C15.9023 4.16716 15.661 4.5713 15.2826 4.5713H1.2073C0.931155 4.5713 0.707298 4.34744 0.707298 4.0713V0.499999C0.707298 0.223857 0.931155 0 1.2073 0H12.6582ZM13.1087 1.25711H10.5952L11.7334 3.65704H14.9346L13.9979 1.62281C13.7845 1.16568 13.1324 1.25711 13.1087 1.25711ZM3.61203 1.25711H2.23673C2.07074 1.25711 1.7862 1.32568 1.7862 1.48567V3.4399C1.7862 3.61133 2.07074 3.65704 2.23673 3.65704H3.61203C3.77801 3.65704 3.90843 3.61133 3.90843 3.4399H3.92029V1.48567C3.92029 1.32568 3.77801 1.25711 3.61203 1.25711ZM9.29107 1.25711H7.91577C7.73793 1.25711 7.46524 1.32568 7.46524 1.48567V3.4399C7.46524 3.61133 7.73793 3.65704 7.91577 3.65704H9.29107C9.45706 3.65704 9.59933 3.61133 9.59933 3.4399H9.61119V1.48567C9.61119 1.32568 9.45706 1.25711 9.29107 1.25711ZM6.44562 1.25711H5.07032C4.90434 1.25711 4.63165 1.32568 4.63165 1.48567V3.4399C4.63165 3.61133 4.90434 3.65704 5.07032 3.65704H6.44562C6.61161 3.65704 6.75388 3.61133 6.75388 3.4399V1.48567C6.75388 1.32568 6.61161 1.25711 6.44562 1.25711Z" fill="#747474"/>
  </svg>`
  const residentialEnergyIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
  <path d="M13.8441 5.49231L14.5246 5.98846C15.4243 6.64615 14.9629 8.07692 13.8441 8.07692V9.23077C14.4785 9.23077 14.9975 9.75 14.9975 10.3846C14.9975 11.0192 14.4785 11.5385 13.8441 11.5385V12.6923C14.4785 12.6923 14.9975 13.2115 14.9975 13.8462C14.9975 14.4808 14.4785 15 13.8441 15H9.2302V10.3846H5.7698V15H1.15594C0.521535 15 0.00247543 14.4808 0.00247543 13.8462C0.00247543 13.2115 0.521535 12.6923 1.15594 12.6923V11.5385C0.521535 11.5385 0.00247543 11.0192 0.00247543 10.3846C0.00247543 9.75 0.521535 9.23077 1.15594 9.23077V8.07692C0.0370794 8.07692 -0.424307 6.64615 0.475396 5.98846L6.81946 1.37308C7.22317 1.08462 7.77683 1.08462 8.18054 1.37308L11.5371 3.81923V0H13.8441V5.49231ZM2.30941 8.07692V9.23077H12.6906V8.07692H2.30941ZM12.6906 11.5385H10.3837V12.6923H12.6906V11.5385ZM2.30941 11.5385V12.6923H4.61634V11.5385H2.30941ZM7.5 3.73846L4.70861 5.76923H10.2914L7.5 3.73846Z" fill="#747474"/>
  </svg>`
  const basicPurchaseIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path d="M5.78581 13.5002H15.4288C15.7245 13.5002 15.9817 13.301 16.0524 13.0117L17.981 5.29784C18.0292 5.10499 17.9842 4.9025 17.8621 4.74822C17.7431 4.59073 17.5567 4.50074 17.3574 4.50074H3.85721C3.85399 4.50074 3.85078 4.50074 3.84756 4.50074L3.18541 2.37942C3.10184 2.11265 2.85433 1.92945 2.57147 1.92945H0.642868C0.286076 1.92945 0 2.2155 0 2.57227C0 2.92904 0.286076 3.21509 0.642868 3.21509H2.09896L4.95008 12.3335C3.8122 12.6389 3.21434 13.5517 3.21434 14.4645C3.21434 15.4544 3.91185 16.454 5.2458 16.6694C5.49973 17.4407 6.21653 18 7.07154 18C7.91049 18 8.61764 17.4632 8.88122 16.7144H11.6873C11.9541 17.4632 12.6581 18 13.497 18C14.3359 18 15.0431 17.4632 15.3067 16.7144H16.0717C16.4285 16.7144 16.7146 16.4283 16.7146 16.0715C16.7146 15.7148 16.4285 15.4287 16.0717 15.4287H15.3099C15.0431 14.6798 14.3392 14.1431 13.5002 14.1431C12.6613 14.1431 11.9541 14.6798 11.6905 15.4287H8.88443C8.61764 14.6798 7.9137 14.1431 7.07476 14.1431C6.26153 14.1431 5.56723 14.6477 5.28437 15.3612C4.74758 15.2166 4.50007 14.8405 4.50007 14.4645C4.50007 13.9856 4.89544 13.5002 5.78581 13.5002ZM7.71441 12.2146H6.25832L5.85652 10.929H7.71441V12.2146ZM7.71441 9.64331H5.45473L5.05294 8.35767H7.71441V9.64331ZM13.5002 5.78638H16.5346L16.2067 7.09774C16.1617 7.0881 16.1199 7.07202 16.0717 7.07202H13.5002V5.78638ZM13.5002 8.35767H15.8917L15.5703 9.64331H13.5002V8.35767ZM13.5002 10.929H15.2488L14.9274 12.2146H13.5002V10.929ZM9.00015 5.78638H12.2145V7.07202H9.00015V5.78638ZM9.00015 8.35767H12.2145V9.64331H9.00015V8.35767ZM9.00015 10.929H12.2145V12.2146H9.00015V10.929ZM4.65115 7.07202L4.24936 5.78638H7.71441V7.07202H4.65115ZM13.5002 15.3644C13.8892 15.3644 14.2074 15.6794 14.2074 16.0715C14.2074 16.4604 13.8892 16.7786 13.5002 16.7786C13.1113 16.7786 12.7931 16.4637 12.7931 16.0715C12.7931 15.6826 13.1113 15.3644 13.5002 15.3644ZM7.07154 15.3644C7.46048 15.3644 7.7787 15.6794 7.7787 16.0715C7.7787 16.4604 7.46048 16.7786 7.07154 16.7786C6.68261 16.7786 6.36439 16.4637 6.36439 16.0715C6.36439 15.6826 6.68261 15.3644 7.07154 15.3644ZM12.5616 1.28663L16.3546 1.91338C16.4767 1.93266 16.586 2.00659 16.6503 2.11265C16.7146 2.21872 16.7306 2.34728 16.6953 2.4662L16.271 3.85791H13.4906L12.5616 1.28663ZM5.01437 3.85791L4.52257 2.3505C4.48722 2.24122 4.49686 2.12551 4.54829 2.02266C4.59972 1.92302 4.69293 1.84588 4.80222 1.81053L10.498 0.0202668C10.7102 -0.0472296 10.9416 0.0588361 11.0252 0.264539L12.5295 3.85791H5.01437Z" fill="#747474"/>
  </svg>`;
  const professionalInstallationIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M13.4059 1.39499L11.4756 2.35053C11.3566 2.40947 11.2814 2.52993 11.2814 2.6618V3.24603C11.2814 3.49726 11.1806 3.73854 11.0009 3.91609L6.66349 8.21088C6.55448 8.31881 6.55448 8.49379 6.66349 8.60172L7.47271 9.40292C7.58172 9.51085 7.75844 9.51085 7.86746 9.40292L12.2052 5.10813C12.3846 4.93058 12.6283 4.83038 12.882 4.83038H13.4721C13.6053 4.83038 13.7269 4.75597 13.7865 4.63809L14.7516 2.72701C14.836 2.55977 14.8029 2.35753 14.6694 2.22492L13.9133 1.4764C13.7794 1.34379 13.5751 1.311 13.4059 1.39499Z" fill="#747474"/>
  <path d="M6.4503 12.8155C6.42947 12.3381 6.82608 11.9454 7.30826 11.966C7.53856 11.976 7.76291 11.8898 7.92587 11.7281C8.25067 11.4065 8.25067 10.8856 7.92587 10.564L5.49003 8.15231C5.16523 7.83073 4.63914 7.83073 4.31434 8.15231L4.30764 8.15894C4.14803 8.31697 4.05837 8.53136 4.05837 8.75496C4.05837 9.22058 3.67738 9.59778 3.20711 9.59778C2.98127 9.59778 2.76473 9.68656 2.60512 9.84459L0.747829 11.6838C-0.249276 12.6711 -0.249276 14.272 0.747829 15.2596C1.74493 16.2468 3.36188 16.2468 4.35936 15.2596L6.20996 13.4273C6.37329 13.2656 6.46035 13.0439 6.4503 12.8155ZM1.85878 13.4745C1.70661 13.6251 1.45808 13.6251 1.30591 13.4745C1.15374 13.3238 1.15374 13.0777 1.30591 12.9271L3.17846 11.0731C3.33063 10.9224 3.57916 10.9224 3.73133 11.0731C3.8835 11.2238 3.8835 11.4698 3.73133 11.6205L1.85878 13.4745ZM3.10368 14.707C2.95151 14.8577 2.70297 14.8577 2.5508 14.707C2.39863 14.5564 2.39863 14.3103 2.5508 14.1596L4.42335 12.3056C4.57552 12.155 4.82405 12.155 4.97622 12.3056C5.12839 12.4563 5.12839 12.7024 4.97622 12.853L3.10368 14.707Z" fill="#747474"/>
  <path d="M6.35096 7.81894L8.26034 5.92848L6.93173 4.60936C6.63893 4.37287 6.49866 4.00229 6.54777 3.63135C6.67353 2.6758 6.36621 1.67532 5.62471 0.941533C4.81772 0.142177 3.69226 -0.148096 2.65348 0.0703453C2.2632 0.152123 2.11996 0.629894 2.40197 0.909117L3.90172 2.394C4.28122 2.76974 4.30949 3.38233 3.94339 3.77096C3.55943 4.17948 2.91318 4.18795 2.51805 3.79674L1.00156 2.29528C0.721777 2.01827 0.238851 2.1542 0.155883 2.53767C-0.0718144 3.58972 0.237735 4.73276 1.08527 5.53654C1.82194 6.23496 2.81756 6.52045 3.76704 6.3941C4.135 6.34511 4.50333 6.4814 4.73773 6.76652L6.14707 8.17626C6.18056 8.04475 6.2479 7.92098 6.35096 7.81894Z" fill="#747474"/>
  <path d="M14.9982 10.2225C14.2616 9.52411 13.266 9.23863 12.3165 9.36498C11.9485 9.41397 11.5802 9.27767 11.3458 8.99256L10.1697 7.8241L8.26331 9.71161C8.161 9.81291 8.03524 9.8818 7.89833 9.91458L9.15178 11.1493C9.44459 11.3858 9.58485 11.7564 9.53574 12.1274C9.40998 13.0829 9.7173 14.0834 10.4588 14.8172C11.2658 15.6162 12.3913 15.9061 13.43 15.688C13.8203 15.6062 13.9636 15.1284 13.6815 14.8492L12.1818 13.3643C11.8023 12.9886 11.774 12.376 12.1401 11.9874C12.5241 11.5789 13.1703 11.5704 13.5655 11.9616L15.082 13.4631C15.3617 13.7401 15.8447 13.6041 15.9276 13.2207C16.1553 12.1694 15.8458 11.0263 14.9982 10.2225Z" fill="#747474"/>
  </svg>`;
  const warrantyRepairSupportIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none">
  <path d="M14.1403 1.77195C12.2395 1.77195 10.3647 1.31625 8.66423 0.441528L8.07942 0.140878C7.71438 -0.0469592 7.28454 -0.0469592 6.9195 0.140878L6.33469 0.441528C4.63532 1.31625 2.76046 1.77195 0.859133 1.77195C0.385017 1.77195 0 2.16763 0 2.65611V9.92507C0 10.9154 0.154979 11.899 0.459536 12.8388C1.35053 15.5902 3.44841 17.7486 6.12193 18.6661L6.70999 18.8679C7.22298 19.044 7.77756 19.044 8.29001 18.8679L8.87807 18.6661C11.5516 17.7492 13.6489 15.5902 14.5405 12.8388C14.845 11.899 15 10.9154 15 9.92507V2.65611C15 2.16763 14.615 1.77195 14.1403 1.77195ZM11.1191 8.22008C10.9614 8.38458 10.8032 8.54908 10.6455 8.71302C9.96184 9.42491 9.27821 10.1368 8.59403 10.8487C8.16311 11.2972 7.73274 11.7456 7.30182 12.1941C6.92976 12.5815 6.29797 12.5726 5.92591 12.1941C5.84491 12.1119 5.76445 12.0296 5.68345 11.9474C5.12078 11.375 4.55756 10.8026 3.99489 10.2296C3.60825 9.83615 3.64011 9.21151 3.99489 8.8136C4.15905 8.62966 4.44416 8.52018 4.68284 8.52018C4.93394 8.52018 5.1926 8.63244 5.3708 8.8136C5.4518 8.89585 5.53226 8.9781 5.61326 9.06035C5.94427 9.39712 6.27475 9.73334 6.60577 10.0701C7.22082 9.42991 7.83588 8.78971 8.45039 8.14895C8.88131 7.70048 9.31169 7.252 9.7426 6.80353C10.1249 6.40563 10.7319 6.43841 11.1185 6.80353C11.2972 6.97247 11.4036 7.26589 11.4036 7.51153C11.4042 7.76994 11.2951 8.03669 11.1191 8.22008Z" fill="#747474"/>
  </svg>`;

  const DETAIL_ACCORDION_ICON_ENUMS = [
    { label: 'Recreational Vehicles', icon: receatVechiclesIcon },
    { label: 'Off-Grid & Backup Power', icon: offGridIcon },
    { label: 'Overlanding & Off Road', icon: offRoadIcon },
    { label: 'Work & Service Vehicles', icon: workServiceVechiclesIcon },
    { label: 'Boats & Leisure Marine', icon: boatsMarineIcon },
    { label: 'Home & Residential Energy', icon: residentialEnergyIcon },
    { label: 'Commercial Marine', icon: commercialMarineIcon },
    { label: 'Basic Purchase Guidance', icon: basicPurchaseIcon },
    { label: 'Professional Installation', icon: professionalInstallationIcon },
    { label: 'Warranty & Repair Support', icon: warrantyRepairSupportIcon },
  ];

  function loadGoogleMaps() {
    if (window.google && window.google.maps) {
      return Promise.resolve(window.google.maps);
    }

    if (window.__ofLocatorGoogleMapsPromise) {
      return window.__ofLocatorGoogleMapsPromise;
    }

    window.__ofLocatorGoogleMapsPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-of-locator-google-maps]');
      if (existing) {
        existing.addEventListener('load', () => resolve(window.google.maps), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = GOOGLE_MAPS_SRC;
      script.defer = true;
      script.dataset.ofLocatorGoogleMaps = 'true';
      script.addEventListener('load', () => resolve(window.google.maps), { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return window.__ofLocatorGoogleMapsPromise;
  }

  if (!window.__ofLocatorSiteCenterPromises) {
    window.__ofLocatorSiteCenterPromises = new Map();
  }

  const IP_API_URL =
    'https://ipapi.co/json/?key=xXiw8W1FVU0Ye1iRbcmqnTTmIb9sA5ip2YP3VBnP6eMNbILci1';

  function getIpCountry() {
    if (!window.__ofLocatorIpCountryPromise) {
      window.__ofLocatorIpCountryPromise = fetch(IP_API_URL)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .catch((error) => {
          console.error('Error fetching IP data:', error);
          return {};
        });
    }

    return window.__ofLocatorIpCountryPromise;
  }

  function parseIpLatLng(ipData) {
    const lat = Number(ipData?.latitude);
    const lng = Number(ipData?.longitude);
    if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
    return { lat, lng };
  }

  function getIpCountryCode(ipData) {
    return normalizeCountryToken(ipData?.country_code || '');
  }

  function normalizeLocatorSiteCountry(value) {
    const country = normalizeCountryToken(value);
    if (country === 'DE') return 'EU';
    return country;
  }

  function getSiteCountryCode(root) {
    return normalizeLocatorSiteCountry(
      root?.dataset?.siteCountry || window.renogyConfig?.country || ''
    );
  }

  function getRequestSite(root) {
    return normalizeLocatorSiteCountry(
      window.renogyConfig?.country || root?.dataset?.siteCountry || ''
    );
  }

  const LOCATION_BLOCKED_COPY = {
    EN: {
      title: 'Location Access Is Blocked',
      body1:
        'Your browser has blocked access to your location. Please allow location access for {host} in your browser settings and refresh the page.',
      body2: 'You can also search by entering a city, state, or ZIP code.',
      confirm: 'Search Manually',
    },
    JP: {
      title: '位置情報へのアクセスがブロックされています',
      body1:
        'ブラウザにより位置情報へのアクセスがブロックされています。ブラウザ設定で {host} の位置情報アクセスを許可し、ページを更新してください。',
      body2: '市区町村、都道府県、郵便番号を入力して検索することもできます。',
      confirm: '手動で検索',
    },
    DE: {
      title: 'Standortzugriff ist blockiert',
      body1:
        'Ihr Browser hat den Zugriff auf Ihren Standort blockiert. Bitte erlauben Sie den Standortzugriff für {host} in Ihren Browsereinstellungen und aktualisieren Sie die Seite.',
      body2: 'Sie können auch nach Stadt, Bundesland oder Postleitzahl suchen.',
      confirm: 'Manuell suchen',
    },
    EU: {
      title: 'Standortzugriff ist blockiert',
      body1:
        'Ihr Browser hat den Zugriff auf Ihren Standort blockiert. Bitte erlauben Sie den Standortzugriff für {host} in Ihren Browsereinstellungen und aktualisieren Sie die Seite.',
      body2: 'Sie können auch nach Stadt, Bundesland oder Postleitzahl suchen.',
      confirm: 'Manuell suchen',
    },
    FR: {
      title: "L'accès à la localisation est bloqué",
      body1:
        "Votre navigateur a bloqué l'accès à votre localisation. Veuillez autoriser l'accès à la localisation pour {host} dans les paramètres de votre navigateur, puis actualisez la page.",
      body2: 'Vous pouvez aussi rechercher en saisissant une ville, un état ou un code postal.',
      confirm: 'Rechercher manuellement',
    },
    ES: {
      title: 'El acceso a la ubicación está bloqueado',
      body1:
        'Tu navegador ha bloqueado el acceso a tu ubicación. Permite el acceso a la ubicación para {host} en la configuración del navegador y actualiza la página.',
      body2: 'También puedes buscar introduciendo una ciudad, un estado o un código postal.',
      confirm: 'Buscar manualmente',
    },
    IT: {
      title: "L'accesso alla posizione è bloccato",
      body1:
        "Il browser ha bloccato l'accesso alla tua posizione. Consenti l'accesso alla posizione per {host} nelle impostazioni del browser e aggiorna la pagina.",
      body2: 'Puoi anche cercare inserendo una città, uno stato o un codice postale.',
      confirm: 'Cerca manualmente',
    },
    NL: {
      title: 'Toegang tot locatie is geblokkeerd',
      body1:
        'Je browser heeft de toegang tot je locatie geblokkeerd. Sta locatietoegang voor {host} toe in je browserinstellingen en vernieuw de pagina.',
      body2: 'Je kunt ook zoeken door een stad, staat of postcode in te voeren.',
      confirm: 'Handmatig zoeken',
    },
  };

  function getLocationBlockedCopy(root) {
    const site = getRequestSite(root) || 'EN';
    return LOCATION_BLOCKED_COPY[site] || LOCATION_BLOCKED_COPY.EN;
  }

  function decodeBase64Utf8(base64) {
    const normalized = String(base64 || '').replace(/\s+/g, '');
    const binary = atob(normalized);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new TextDecoder('utf-8').decode(bytes);
  }

  // Retail Store 等接口只返回 id，不返回 referId；前端多处依赖 referId 过滤/展示
  function normalizeInstallerItem(item) {
    if (!item || typeof item !== 'object') return null;
    const id = item.id ?? item.referId;
    const referId = item.referId ?? item.id;
    if (id == null && referId == null) return null;
    return {
      ...item,
      id: id ?? referId,
      referId: referId ?? id,
    };
  }

  function normalizeInstallerItems(list) {
    if (!Array.isArray(list)) return [];
    return list.map(normalizeInstallerItem).filter(Boolean);
  }

  function parseInstallerSearchData(data) {
    if (Array.isArray(data)) return normalizeInstallerItems(data);
    if (data == null) return [];
    if (typeof data !== 'string') return [];

    const trimmed = data.trim();
    if (!trimmed) return [];

    try {
      let decoded = decodeBase64Utf8(trimmed);

      if (!decoded.startsWith('[') && !decoded.startsWith('{')) {
        decoded = decodeBase64Utf8(decoded);
      }

      const parsed = JSON.parse(decoded);
      return normalizeInstallerItems(Array.isArray(parsed) ? parsed : []);
    } catch (error) {
      console.error('Failed to decode installer search data:', error);
      return [];
    }
  }

  function isCountryMatchingSite(countryCode, siteCountry) {
    const detected = normalizeCountryToken(countryCode);
    const site = normalizeLocatorSiteCountry(siteCountry);
    if (!site || !detected) return false;
    if (detected === site) return true;

    const matchers = SITE_COUNTRY_MATCHERS[site] || { codes: [site], names: [] };
    return matchers.codes.some((code) => normalizeCountryToken(code) === detected);
  }

  function isValidIpCountryResponse(ipData) {
    return Boolean(ipData && !ipData.error && ipData.country_code);
  }

  function getDetectedCountryCode(ipData) {
    if (!isValidIpCountryResponse(ipData)) return '';
    return getIpCountryCode(ipData);
  }

  function resolveLocatorCountryCode(ipData, root) {
    const siteCountry = getSiteCountryCode(root);
    const detectedCountry = getDetectedCountryCode(ipData);

    if (detectedCountry && isCountryMatchingSite(detectedCountry, siteCountry)) {
      return detectedCountry;
    }

    return getSiteDefaultCountryCode(siteCountry);
  }

  function shouldUseIpLatLng(ipData, root) {
    if (!isValidIpCountryResponse(ipData)) return false;
    if (!parseIpLatLng(ipData)) return false;

    return isCountryMatchingSite(getIpCountryCode(ipData), getSiteCountryCode(root));
  }

  function getSiteCountryGeocodeQuery(root) {
    const siteCountry = getSiteCountryCode(root);
    const defaultQuery = SITE_DEFAULT_GEOCODE_QUERIES[siteCountry];
    if (defaultQuery) return defaultQuery;

    return (
      root?.dataset?.siteCountryLabel ||
      root?.dataset?.siteCountry ||
      window.renogyConfig?.country ||
      ''
    );
  }

  function geocodeSiteCountryCenter(root) {
    const cacheKey = root?.dataset?.locatorInstance || 'of-locator-default';

    if (window.__ofLocatorSiteCenterPromises.has(cacheKey)) {
      return window.__ofLocatorSiteCenterPromises.get(cacheKey);
    }

    const promise = getIpCountry().then((ipData) => {
      if (shouldUseIpLatLng(ipData, root)) {
        const ipLatLng = parseIpLatLng(ipData);
        if (ipLatLng) {
          return ipLatLng;
        }
      }

      return loadGoogleMaps().then(() => {
        const query = getSiteCountryGeocodeQuery(root);
        if (!query || !window.google?.maps?.Geocoder) {
          return DEFAULT_LAT_LNG;
        }

        return new Promise((resolve) => {
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: query }, (results, status) => {
            if (status === 'OK' && results?.[0]?.geometry?.location) {
              const location = results[0].geometry.location;
              resolve({
                lat: location.lat(),
                lng: location.lng(),
              });
              return;
            }

            resolve(DEFAULT_LAT_LNG);
          });
        });
      });
    });

    window.__ofLocatorSiteCenterPromises.set(cacheKey, promise);
    return promise;
  }

  const OF_LOCATOR_SELECTORS = {
    tagsContainer: '[data-of-locator-tags]',
    tagsContainerM: '[data-of-locator-tags-mobile]',
    panelContainer: '[data-of-locator-panel]',
    searchInput: '[data-of-locator-search-input]',
    distance: '[data-of-locator-distance]',
    defIcon: '[data-of-locator-distance-icon-default]',
    selectIcon: '[data-of-locator-distance-icon-selected]',
    distanceNum: '[data-of-locator-distance-num]',
    distanceList: '[data-of-locator-distance-list]',
    distanceOption: '[data-of-locator-distance-list] .option',
    myLocation: '[data-of-locator-my-location]',
    mapContainer: '[data-of-locator-map]',
    searchBtn: '[data-of-locator-search-btn]',
    searchSuggestions: '[data-of-locator-search-suggestions]',
    serviceType: '[data-of-locator-service-type]',
    tagMiles: '.tag-miles',
  };

  const INSTALLER_SEARCH_SUGGESTION_LIMIT = 10;
  const INSTALLER_SEARCH_INPUT_DEBOUNCE_MS = 200;
  const INSTALLER_SUGGESTION_SEARCH_DISTANCE = 1000000;
  const DEALER_SEARCH_SUBMIT_DEBOUNCE_MS = 500;
  const BACK_HEADER_DEBOUNCE_MS = 400;

  const SITE_COUNTRY_MATCHERS = {
    US: { codes: ['US'], names: ['united states', 'united states of america'] },
    UK: { codes: ['GB', 'UK'], names: ['united kingdom'] },
    CA: { codes: ['CA'], names: ['canada'] },
    AU: { codes: ['AU'], names: ['australia'] },
    JP: { codes: ['JP'], names: ['japan'] },
    FR: { codes: ['FR'], names: ['france'] },
    NL: { codes: ['NL'], names: ['netherlands'] },
    IT: { codes: ['IT'], names: ['italy'] },
    ES: { codes: ['ES'], names: ['spain'] },
    ZA: { codes: ['ZA'], names: ['south africa'] },
    EU: {
      codes: ['DE', 'FR', 'IT', 'ES', 'NL'],
      names: ['germany', 'france', 'italy', 'spain', 'netherlands'],
    },
  };

  const SITE_DEFAULT_COUNTRY_CODES = {
    EU: 'DE',
  };

  const SITE_DEFAULT_GEOCODE_QUERIES = {
    EU: 'Germany',
  };

  function getSiteDefaultCountryCode(siteCountry) {
    const site = normalizeLocatorSiteCountry(siteCountry);
    return SITE_DEFAULT_COUNTRY_CODES[site] || site;
  }

  function parseLatLng(lat, lng) {
    const latitude = Number(lat);
    const longitude = Number(lng);
    if (Number.isNaN(latitude) || Number.isNaN(longitude)) return null;
    return { lat: latitude, lng: longitude };
  }

  function normalizeCountryToken(value) {
    return String(value || '').trim().toUpperCase();
  }

  function extractCountryFromAddressComponents(components) {
    const countryComponent = (components || []).find((component) =>
      component.types?.includes('country')
    );

    if (!countryComponent) return null;

    return {
      code: countryComponent.short_name || '',
      name: countryComponent.long_name || '',
    };
  }

  function extractCountryFromGeocoderResult(result) {
    return extractCountryFromAddressComponents(result?.address_components);
  }

  function extractCountryFromPlace(place) {
    return extractCountryFromAddressComponents(place?.address_components);
  }

  function normalizeSearchQuery(query) {
    return String(query || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function isCertifiedStatus(value) {
    if (value === true || value === 1) return true;
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === 'true' || normalized === '1';
    }
    return false;
  }

  function isLocatorDesktop() {
    return window.matchMedia('(min-width: 861px)').matches;
  }

  function copyLocatorPhone(phone, phoneLink) {
    const text = String(phone || '').trim();
    if (!text) return Promise.resolve(false);

    const showSuccess = () => {
      const successIcon = phoneLink
        ?.closest('.detail-contact-item__phone-wrap')
        ?.querySelector('.detail-contact-item__copy-success');
      if (!successIcon) return;

      successIcon.hidden = false;
      window.clearTimeout(successIcon.__hideTimer);
      successIcon.__hideTimer = window.setTimeout(() => {
        successIcon.hidden = true;
      }, 1500);
    };

    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text)
        .then(() => {
          showSuccess();
          return true;
        })
        .catch(() => false);
    }

    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showSuccess();
      return Promise.resolve(true);
    } catch {
      return Promise.resolve(false);
    }
  }

  function collectInstallerSearchValues(value, collected, depth = 0) {
    if (value == null || depth > 5) return;

    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      const text = String(value).trim();
      if (text) collected.push(text);
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((entry) => collectInstallerSearchValues(entry, collected, depth + 1));
      return;
    }

    if (typeof value === 'object') {
      Object.values(value).forEach((entry) => collectInstallerSearchValues(entry, collected, depth + 1));
    }
  }

  function getInstallerSearchHaystack(item) {
    const parts = [];
    collectInstallerSearchValues(item, parts);

    if (!item) {
      return { text: '', digits: '' };
    }

    const phone = String(item.serviceCall || item.phone || '').trim();
    const email = String(item.email || '').trim();
    const website = formatWebsiteLabel(item.website || '');
    const address = String(item.address || '').trim();
    const distance = String(item.distance ?? '').trim();
    const introduction = String(item.introduction || '').trim();
    const serviceTypes = parseSpecializationAreas(item);

    parts.push(
      phone,
      email,
      website,
      formatWebsiteUrl(item.website || ''),
      address,
      distance,
      introduction,
      item.tag,
      item.referId,
      item.serverType,
      item.name,
      item.city,
      item.state,
      item.zipCode,
      item.zip,
      item.country,
      item.latitude,
      item.longitude
    );
    parts.push(...serviceTypes);

    if (distance) {
      parts.push(`${distance}mi`, `${distance} mi`, `${distance}miles`, `${distance} miles`);
    }

    const normalizedParts = parts
      .map((part) => String(part).trim().toLowerCase())
      .filter(Boolean);

    const text = normalizedParts.join(' ');
    const digits = normalizedParts.join('').replace(/\D/g, '');

    return { text, digits };
  }

  function installerSearchTokenMatches(token, haystack) {
    if (!token) return true;
    if (haystack.text.includes(token)) return true;

    const tokenDigits = token.replace(/\D/g, '');
    if (tokenDigits.length >= 7 && haystack.digits.includes(tokenDigits)) return true;

    return false;
  }

  function filterInstallers(query, list) {
    const normalizedQuery = normalizeSearchQuery(query);
    if (!normalizedQuery) return [];

    const tokens = normalizedQuery.split(' ').filter(Boolean);
    return (list || []).filter((item) => {
      if (!item?.referId) return false;
      const haystack = getInstallerSearchHaystack(item);
      return tokens.every((token) => installerSearchTokenMatches(token, haystack));
    });
  }

  function ensureMapContainerId(root, mapContainer) {
    const instanceId =
      root.dataset.locatorInstance || root.dataset.locatorInstanceId || 'of-locator-' + Math.random().toString(36).slice(2, 9);
    root.dataset.locatorInstanceId = instanceId;
    mapContainer.id = instanceId + '-map';
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /** "E,Tacoma,WA" → "E, Tacoma, WA"；已有空格则保持 */
  function formatAddressDisplay(address) {
    return String(address || '')
      .trim()
      .replace(/,\s*/g, ', ');
  }

  function formatWebsiteUrl(url) {
    const value = String(url || '').trim();
    if (!value) return '';
    return /^https?:\/\//i.test(value) ? value : `https://${value}`;
  }

  function formatWebsiteLabel(url) {
    return String(url || '')
      .trim()
      .replace(/^https?:\/\//i, '')
      .replace(/\/$/, '');
  }

  function formatIntroduction(text, name) {
    const value = String(text || '').trim();
    if (!value || /^none$/i.test(value)) return '';
    return value.replace(/\(COMPANY NAME\)/gi, name).replace(/\{COMPANY NAME\}/gi, name);
  }

  function parseRawList(raw, fallback = []) {
    if (Array.isArray(raw)) {
      return raw.map((item) => String(item).trim()).filter(Boolean);
    }

    if (typeof raw === 'string' && raw.trim()) {
      return raw
        .split(/[,;|]/)
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return [...fallback];
  }

  function parseSpecializationAreas(detail) {
    const raw =
      detail.specializationList ||
      detail.specializationAreas ||
      detail.serverTypeList ||
      detail.serverTypes ||
      detail.serverType;

    return parseRawList(raw);
  }

  function parseServicesOffered(detail) {
    const raw =
      detail.servicesOffered ||
      detail.serviceOfferedList ||
      detail.offerServiceList ||
      detail.offeredServices ||
      detail.serviceList;

    return parseRawList(raw);
  }

  function normalizeDetailAccordionIconLabel(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getDetailAccordionEnumIcon(type) {
    const key = normalizeDetailAccordionIconLabel(type);
    const matchedIcon = DETAIL_ACCORDION_ICON_ENUMS.find(
      (item) => normalizeDetailAccordionIconLabel(item.label) === key
    );

    return matchedIcon?.icon || '';
  }

  function getServiceTypeIcon(type) {
    return getDetailAccordionEnumIcon(type);
  }

  function getServicesOfferedIcon(type) {
    return getDetailAccordionEnumIcon(type);
  }

  function getDetailAccordionChevron() {
    return '<svg class="detail-accordion__chevron" xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1L5 5L9 1" stroke="#0B3587" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  const DETAIL_ACCORDION_TOGGLE_DEBOUNCE_MS = 300;
  const detailAccordionToggleAt = new WeakMap();

  function setDetailAccordionExpanded(accordion, expanded) {
    const trigger = accordion?.querySelector('.detail-accordion__trigger');
    if (!accordion || !trigger) return;

    accordion.classList.toggle('is-collapsed', !expanded);
    trigger.setAttribute('aria-expanded', String(expanded));
  }

  function toggleDetailAccordion(accordion) {
    if (!accordion) return;

    const now = Date.now();
    const lastAt = detailAccordionToggleAt.get(accordion) || 0;
    if (now - lastAt < DETAIL_ACCORDION_TOGGLE_DEBOUNCE_MS) return;

    detailAccordionToggleAt.set(accordion, now);
    setDetailAccordionExpanded(accordion, accordion.classList.contains('is-collapsed'));
  }

  function buildDetailAccordionList(items, getIcon) {
    return (items || [])
      .map(
        (item) => `<li class="detail-accordion-item">
          <span class="detail-accordion-item__icon">${getIcon(item)}</span>
          <span class="detail-accordion-item__text">${escapeHtml(item)}</span>
        </li>`
      )
      .join('');
  }

  function buildDetailAccordionSection({
    title,
    panelHtml,
    collapsed = true,
  }) {
    const collapsedClass = collapsed ? ' is-collapsed' : '';

    return `<section class="detail-accordion${collapsedClass}">
      <button type="button" class="detail-accordion__trigger" aria-expanded="${collapsed ? 'false' : 'true'}">
        <span class="detail-accordion__heading">
          <span class="detail-accordion__title">${escapeHtml(title)}</span>
          ${getDetailAccordionChevron()}
        </span>
      </button>
      <div class="detail-accordion__panel">${panelHtml}</div>
    </section>`;
  }

  function buildDetailAccordionsHtml(detail) {
    const specializationAreas = parseSpecializationAreas(detail);
    const servicesOffered = parseServicesOffered(detail);
    const introduction = formatIntroduction(detail.introduction, detail.name);
    const sections = [];

    if (specializationAreas.length > 0) {
      sections.push(
        buildDetailAccordionSection({
          title: 'Specialization Areas',
          panelHtml: `<ul class="detail-accordion-list">${buildDetailAccordionList(
            specializationAreas,
            getServiceTypeIcon
          )}</ul>`,
        })
      );
    }

    if (servicesOffered.length > 0) {
      sections.push(
        buildDetailAccordionSection({
          title: 'Services Offered',
          panelHtml: `<ul class="detail-accordion-list">${buildDetailAccordionList(
            servicesOffered,
            getServicesOfferedIcon
          )}</ul>`,
        })
      );
    }

    if (introduction) {
      sections.push(
        buildDetailAccordionSection({
          title: 'Introduction',
          panelHtml: `<p class="introduction-content">${escapeHtml(introduction)}</p>`,
        })
      );
    }

    if (!sections.length) return '';
    return `<div class="detail-accordions">${sections.join('')}</div>`;
  }

  function normalizeDetail(detail) {
    const name = String(detail?.name || 'Roam N\' Roost').trim() || 'Roam N\' Roost';
    const introduction = String(detail?.introduction || '').trim();

    return {
      ...detail,
      name,
      website: String(detail?.website || 'www.renogy.com').trim() || 'www.renogy.com',
      serviceCall: String(detail?.serviceCall || detail?.phone || '(01224) 418 318').trim() || '(01224) 418 318',
      email: String(detail?.email || 'ag@dronenerds.com').trim() || 'ag@dronenerds.com',
      tag: String(detail?.tag || 'Renogy Certified').trim() || 'Renogy Certified',
      introduction,
    };
  }

  function buildContactRows(detail) {
    const rows = [];
    const address = formatAddressDisplay(detail.address);
    const website = formatWebsiteLabel(detail.website);
    const websiteUrl = formatWebsiteUrl(detail.website);
    const phone = String(detail.serviceCall || detail.phone || '').trim();
    const email = String(detail.email || '').trim();

    if (address) {
      rows.push(`<li class="detail-contact-item">
        <span class="detail-contact-item__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
            <path d="M6 0C9.31376 0 12 2.32004 12 6.29724C12 9.32323 8.52671 13.6925 6.86541 15.6092C6.38753 16.1408 5.58529 16.1196 5.13494 15.6092C3.474 13.6935 0 9.32389 0 6.29724C0 2.32004 2.68624 0 6 0ZM6 3.64577C5.43836 3.64577 4.89973 3.85528 4.5026 4.22822C4.10546 4.60115 3.88235 5.10696 3.88235 5.63437C3.88235 6.16178 4.10546 6.66759 4.5026 7.04053C4.89973 7.41346 5.43836 7.62297 6 7.62297C6.56164 7.62297 7.10027 7.41346 7.4974 7.04053C7.89454 6.66759 8.11765 6.16178 8.11765 5.63437C8.11765 5.10696 7.89454 4.60115 7.4974 4.22822C7.10027 3.85528 6.56164 3.64577 6 3.64577Z" fill="#747474"/>
          </svg>
        </span>
        <span class="detail-contact-item__text">${escapeHtml(address)}</span>
      </li>`);
    }

    if (website) {
      rows.push(`<li class="detail-contact-item">
        <span class="detail-contact-item__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M9.90538 4.91131L11.9487 6.95468C12.2803 7.28185 12.5439 7.67136 12.7243 8.10081C12.9047 8.53026 12.9984 8.99116 13 9.45696C13.0015 9.92277 12.9109 10.3843 12.7334 10.8149C12.5559 11.2456 12.2949 11.6369 11.9655 11.9662C11.6362 12.2956 11.2449 12.5566 10.8142 12.7341C10.3836 12.9116 9.92208 13.0022 9.45628 13.0007C8.99047 12.9991 8.52958 12.9054 8.10013 12.725C7.67069 12.5446 7.28117 12.281 6.95401 11.9494L6.27332 11.2687C6.18128 11.1799 6.10785 11.0737 6.05731 10.9562C6.00677 10.8387 5.98014 10.7123 5.97897 10.5844C5.9778 10.4565 6.00211 10.3297 6.05049 10.2113C6.09886 10.0929 6.17034 9.98527 6.26073 9.89479C6.35113 9.8043 6.45865 9.73273 6.577 9.68424C6.69536 9.63575 6.82218 9.61132 6.95008 9.61237C7.07798 9.61342 7.20439 9.63993 7.32193 9.69036C7.43948 9.74079 7.5458 9.81412 7.6347 9.90607L8.31668 10.5874C8.61824 10.8863 9.02591 11.0535 9.45047 11.0525C9.87503 11.0515 10.2819 10.8824 10.5821 10.5821C10.8822 10.2819 11.0513 9.87494 11.0521 9.45038C11.053 9.02582 10.8857 8.6182 10.5867 8.31672L8.54336 6.27335C8.3225 6.05239 8.04198 5.90068 7.73617 5.8368C7.43036 5.77292 7.11256 5.79966 6.82172 5.91373C6.71812 5.95483 6.62094 5.99679 6.53018 6.0396L6.23222 6.17895C5.83408 6.35875 5.52777 6.43581 5.13797 6.04666C4.57801 5.48669 4.72314 4.96975 5.40576 4.49904C6.08575 4.03114 6.90814 3.81617 7.73012 3.89149C8.5521 3.9668 9.32174 4.32763 9.90538 4.91131ZM6.04599 1.0519L6.72668 1.7326C6.90223 1.91419 6.99944 2.15746 6.99736 2.41002C6.99529 2.66258 6.8941 2.90423 6.71559 3.08291C6.53708 3.26158 6.29553 3.363 6.04297 3.36532C5.79042 3.36763 5.54705 3.27065 5.3653 3.09527L4.68397 2.41458C4.53592 2.2612 4.3588 2.13885 4.16296 2.05466C3.96712 1.97046 3.75647 1.92612 3.54331 1.9242C3.33014 1.92229 3.11873 1.96285 2.92141 2.04352C2.72409 2.12418 2.54481 2.24334 2.39403 2.39403C2.24325 2.54473 2.124 2.72394 2.04322 2.92122C1.96244 3.11849 1.92176 3.32988 1.92356 3.54305C1.92535 3.75621 1.96958 3.96689 2.05366 4.16278C2.13774 4.35867 2.25999 4.53585 2.41328 4.68399L4.45664 6.72736C4.6775 6.94831 4.95802 7.10003 5.26383 7.1639C5.56964 7.22778 5.88744 7.20104 6.17828 7.08697C6.28188 7.04587 6.37906 7.00392 6.46982 6.9611L6.76778 6.82175C7.16592 6.64195 7.47288 6.56489 7.86203 6.95404C8.42199 7.51401 8.27686 8.03095 7.59424 8.50166C6.91425 8.96957 6.09186 9.18453 5.26988 9.10922C4.4479 9.03391 3.67826 8.67307 3.09462 8.08939L1.05126 6.04602C0.719682 5.71886 0.456099 5.32934 0.275682 4.89989C0.0952659 4.47044 0.00158032 4.00954 1.98215e-05 3.54374C-0.00154068 3.07793 0.0890548 2.61642 0.26659 2.18577C0.444125 1.75512 0.705092 1.36385 1.03447 1.03447C1.36384 0.705096 1.75512 0.444127 2.18576 0.266591C2.61641 0.0890551 3.07792 -0.00154069 3.54372 1.98216e-05C4.00953 0.00158033 4.47042 0.0952664 4.89987 0.275684C5.32931 0.456101 5.71883 0.720328 6.04599 1.0519Z" fill="#747474"/>
          </svg>
        </span>
        <a class="detail-contact-item__link" href="${escapeHtml(websiteUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(website)}</a>
      </li>`);
    }

    if (phone) {
      rows.push(`<li class="detail-contact-item">
        <span class="detail-contact-item__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
              <path d="M9.76638 8.33994L9.41249 8.68635C9.41249 8.68635 8.57016 9.50918 6.27185 7.26246C3.97353 5.01573 4.81586 4.1929 4.81586 4.1929L5.0383 3.97419C5.58818 3.43737 5.64029 2.57477 5.16041 1.94465L4.18042 0.657637C3.5862 -0.12237 2.43898 -0.225606 1.75843 0.439694L0.537329 1.63264C0.200553 1.963 -0.0250007 2.38971 0.00222132 2.86383C0.0722209 4.07743 0.630661 6.68739 3.74486 9.73248C7.04806 12.9611 10.1475 13.0896 11.4145 12.9733C11.8158 12.9366 12.1643 12.7363 12.445 12.461L13.5495 11.3812C14.2961 10.6524 14.0861 9.40212 13.131 8.89206L11.6455 8.09752C11.0186 7.76334 10.2564 7.86123 9.76638 8.33994Z" fill="#0B3587"></path>
          </svg>
        </span>
        <span class="detail-contact-item__phone-wrap">
          <a class="detail-contact-item__link detail-contact-item__link--phone" href="tel:${escapeHtml(phone.replace(/\s/g, ''))}" data-of-locator-phone="${escapeHtml(phone)}">${escapeHtml(phone)}</a>
          <span class="detail-contact-item__copy-success" aria-hidden="true" hidden>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" fill="#0B3587"/>
              <path d="M4.5 8.2L6.8 10.5L11.5 5.8" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </span>
      </li>`);
    }

    if (email) {
      rows.push(`<li class="detail-contact-item">
        <span class="detail-contact-item__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
            <path d="M3.71654 0H10.2835C10.831 0 11.2722 -1.24176e-08 11.6305 0.0286667C11.9983 0.0586667 12.3216 0.122 12.6206 0.272667C13.0962 0.512248 13.4829 0.89476 13.7252 1.36533C13.8774 1.66133 13.9407 1.98133 13.971 2.34533C13.9755 2.39867 13.9791 2.45356 13.9818 2.51C14.002 2.583 14.0053 2.65959 13.9912 2.734C14 3.00733 14 3.32 14 3.67867V7.32133C14 7.86333 14 8.30067 13.971 8.65467C13.9407 9.01867 13.8767 9.33867 13.7245 9.63467C13.4825 10.1054 13.096 10.4881 12.6206 10.728C12.3216 10.8787 11.9983 10.9413 11.6305 10.9713C11.2722 11 10.831 11 10.2835 11H3.71654C3.16896 11 2.7278 11 2.36948 10.9713C2.00173 10.9413 1.67844 10.878 1.37939 10.7273C0.904075 10.4876 0.517637 10.1051 0.275474 9.63467C0.123256 9.33867 0.0599442 9.01867 0.0296354 8.65467C2.00728e-08 8.30067 0 7.86333 0 7.32133V3.67867C0 3.32 7.52729e-09 3.00733 0.0087559 2.734C-0.0052717 2.65959 -0.00204756 2.583 0.0181853 2.51C0.0213284 2.45311 0.0251452 2.39844 0.0296354 2.346C0.0592707 1.98133 0.123256 1.66133 0.275474 1.36533C0.517522 0.894614 0.903972 0.511869 1.37939 0.272C1.67844 0.121333 2.00173 0.0586667 2.36948 0.0286667C2.7278 -1.24176e-08 3.16896 0 3.71654 0ZM12.9607 2.394C12.9351 2.112 12.89 1.946 12.8247 1.81933C12.6795 1.53694 12.4478 1.3073 12.1626 1.16333C12.0293 1.09667 11.8535 1.05 11.5477 1.02533C11.2365 1.00067 10.8358 1 10.2619 1H3.73809C3.16425 1 2.76417 1 2.45165 1.02533C2.14654 1.05 1.97075 1.09667 1.83806 1.16333C1.55266 1.30719 1.32064 1.53684 1.17531 1.81933C1.11065 1.946 1.06485 2.112 1.03926 2.394L5.48725 5.32933C6.16752 5.77867 6.40527 5.926 6.64707 5.98333C6.87908 6.03833 7.12092 6.03833 7.35293 5.98333C7.5954 5.926 7.83181 5.77867 8.51342 5.32933L12.9607 2.394Z" fill="#747474"></path>
          </svg>
        </span>
        <a class="detail-contact-item__link" href="mailto:${escapeHtml(email)}">${escapeHtml(email)}</a>
      </li>`);
    }

    return rows.join('');
  }

  function buildBusinessDetailHtml(detail, options = {}) {
    const normalized = normalizeDetail(detail);
    const name = normalized.name;
    const directionsData = { ...normalized };
    delete directionsData.name;
    const contactRows = buildContactRows(normalized);
    const accordionsHtml = buildDetailAccordionsHtml(normalized);
    const certifiedLabel = String(options.certifiedLabel || 'Renogy Certified').trim() || 'Renogy Certified';
    const certifiedIconUrl = String(options.certifiedIconUrl || '').trim();
    const showCertified = isCertifiedStatus(normalized.certifiedStatus);
    const showCertifiedIcon = showCertified && certifiedIconUrl;
    const certifiedIconMarkup = showCertifiedIcon
      ? `<span class="detail-certified__icon" aria-hidden="true">
            <img src="${escapeHtml(certifiedIconUrl)}" alt="" width="24" height="24" loading="lazy" />
          </span>`
      : '';
    const certifiedMarkup = showCertified
      ? `<div class="detail-certified">
          ${certifiedIconMarkup}
          <span class="detail-certified__text">${escapeHtml(certifiedLabel)}</span>
        </div>`
      : '';

    return `<div class="business-detail">
      <div class="back-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none" aria-hidden="true">
          <path d="M5.5 0.5L0.5 5L5.5 9.5" stroke="#474747" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="text">Back</span>
      </div>
      <div class="detail-content">
        <div class="detail-header-row">
          <h1 class="business-name">${escapeHtml(name)}</h1>
          <div class="directions-item" data-location='${JSON.stringify(directionsData).replace(/'/g, '&#39;')}'>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
              <mask id="mask0_9401_2185" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="13">
              <path d="M12 0H0V12.0165H12V0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_9401_2185)">
              <path d="M6.61212 11.9998C6.58805 11.9998 6.56449 11.9972 6.54197 11.9943C6.3224 11.9642 6.14754 11.789 6.11642 11.5682L5.41662 6.58283L0.431926 5.88287C0.2115 5.85278 0.0359499 5.67757 0.00482881 5.45715C-0.0261203 5.23741 0.0940654 5.02111 0.29747 4.93032L11.2899 0.0494769C11.3546 0.0214508 11.4223 0.00683594 11.4914 0.00683594C11.6272 0.00683594 11.7536 0.0587617 11.8473 0.152469C11.9937 0.297586 12.0358 0.521623 11.952 0.709724L7.07068 11.702C6.98953 11.8827 6.80968 11.9998 6.61212 11.9998ZM2.30228 5.13562L5.92952 5.64439C6.15012 5.67516 6.32498 5.85071 6.35559 6.0708L6.8659 9.69752L6.00001 5.79415L2.30228 5.13562Z" fill="#0B3587"/>
              </g>
            </svg>
            <span class="direction-text">Directions</span>
          </div>
        </div>
        <ul class="detail-contact-list">${contactRows}</ul>
        ${certifiedMarkup}
        ${accordionsHtml}
      </div>
    </div>`;
  }

  function getPanelItemFields(v) {
    return {
      address: formatAddressDisplay(v.address),
      distance:String(v.distance || ''),
      website: formatWebsiteLabel(v.website || 'www.renogy.com'),
      websiteUrl: formatWebsiteUrl(v.website || 'www.renogy.com'),
      phone: String(v.serviceCall || v.phone || '(01224) 418 318').trim(),
      email: String(v.email || 'ag@dronenerds.com').trim(),
    };
  }

  function buildBusinessInfoHtml(name, distance, location) {
    const distanceValue = String(distance ?? '').trim();
    const distanceText = distanceValue ? `${escapeHtml(distanceValue)}mi` : '0mi';
    const directionsPayload = {
      address: location?.address || '',
      latitude: location?.latitude,
      longitude: location?.longitude,
    };
    const hasDirections =
      directionsPayload.address &&
      directionsPayload.latitude != null &&
      directionsPayload.longitude != null;
    // const directionsMarkup = hasDirections
    //   ? `<button
    //       type="button"
    //       class="business-info__directions directions-item"
    //       data-location='${JSON.stringify(directionsPayload).replace(/'/g, '&#39;')}'
    //     >
    //       <span class="direction-text">Directions</span>
    //     </button>`
    //   : '';

    return `<div class="business-info">
        <h1 style="font-size:14px;font-weight:500;" class="business-info__name">${escapeHtml(name)}</h1>
        <p class="business-info__distance">${distanceText}</p>
      </div>`;

      // ${directionsMarkup}
  }

  function getNearestItemId(items) {
    let nearestId = null;
    let minDistance = Infinity;

    (items || []).forEach((item) => {
      if (!item?.referId) return;
      const distance = parseFloat(item.distance);
      if (Number.isNaN(distance)) return;
      if (distance < minDistance) {
        minDistance = distance;
        nearestId = item.id;
      }
    });

    return nearestId;
  }

  function buildPanelItemData(item) {
    return {
      id: item.id,
      referId: item.referId,
      name: item.name,
      address: item.address,
      latitude: item.latitude,
      longitude: item.longitude,
      distance: item.distance,
      website: item.website,
      serviceCall: item.serviceCall || item.phone,
      phone: item.phone,
      email: item.email,
      tag: item.tag,
      certifiedStatus: item.certifiedStatus,
      introduction: item.introduction,
      serverType: item.serverType,
      serverTypeList: item.serverTypeList,
      serverTypes: item.serverTypes,
      specializationList: item.specializationList,
      specializationAreas: item.specializationAreas,
      servicesOffered: item.servicesOffered,
      serviceOfferedList: item.serviceOfferedList,
      offerServiceList: item.offerServiceList,
      offeredServices: item.offeredServices,
      serviceList: item.serviceList,
    };
  }

  function serializePanelItemData(item) {
    return escapeHtml(JSON.stringify(buildPanelItemData(item)));
  }

  function parsePanelItemData(raw) {
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      console.error('Failed to parse panel item data:', error);
      return null;
    }
  }

  function openLocatorDirections(location) {
    if (!location?.address || location.latitude == null || location.longitude == null) return;

    const url =
      'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(location.address) +
      '&destination_place_id=' +
      encodeURIComponent('@' + location.latitude + ',' + location.longitude);
    window.open(url, '_blank');
  }

  function buildPanelItem(v, options = {}) {
    const contentJson = serializePanelItemData(v);
    const fields = getPanelItemFields(v);
    const nearestLabel = options.nearestLabel || 'Nearest';
    const serviceTagLabel = options.serviceTagLabel || 'Offers installation services';
    const nearestBadge = options.isNearest
      ? `<span class="panel-item-nearest-badge">${escapeHtml(nearestLabel)}</span>`
      : '';
    const installationService = v?.installationService;
    const hasServiceTag =
      installationService === true ||
      installationService === 1 ||
      installationService === '1' ||
      String(installationService).toLowerCase() === 'true';
    const serviceTagHtml = hasServiceTag
      ? `<div class="of-locator-service-tag">
        <span class="of-locator-service-tag__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path d="M0 7C0 3.13401 3.13401 0 7 0H14C17.866 0 21 3.13401 21 7V14C21 17.866 17.866 21 14 21H7C3.13401 21 0 17.866 0 14V7Z" fill="#0B3587"/>
            <path d="M16.745 13.2733L14.0007 10.5291C13.4593 9.9877 12.6507 9.88224 11.9992 10.2033L9.50092 7.70511V6.24978L6.50109 4L5.00117 5.49985L7.25105 8.49956H8.70643L11.2047 10.9978C10.886 11.6493 10.9891 12.4578 11.5305 12.9991L14.2749 15.7434C14.617 16.0855 15.1701 16.0855 15.51 15.7434L16.745 14.5083C17.0849 14.1662 17.0849 13.6131 16.745 13.2733ZM12.775 9.27292C13.4382 9.27292 14.0616 9.53071 14.5303 9.99941L14.985 10.4541C15.3553 10.2924 15.7068 10.0674 16.0115 9.76272C16.881 8.89327 17.1763 7.66995 16.8997 6.55912C16.8482 6.34821 16.5833 6.27556 16.4287 6.43023L14.685 8.17381L13.0937 7.90899L12.8289 6.31774L14.5725 4.57416C14.7272 4.41949 14.6522 4.15467 14.4389 4.10077C13.3281 3.82658 12.1047 4.12186 11.2375 4.98897C10.5696 5.65687 10.2556 6.53803 10.272 7.41685L12.1961 9.34089C12.3859 9.29636 12.5828 9.27292 12.775 9.27292ZM10.3399 11.1946L9.0111 9.86583L5.43943 13.4397C4.85352 14.0256 4.85352 14.9747 5.43943 15.5606C6.02533 16.1465 6.9745 16.1465 7.5604 15.5606L10.4571 12.664C10.279 12.1976 10.2251 11.6891 10.3399 11.1946ZM6.50109 15.0614C6.19173 15.0614 5.93862 14.8083 5.93862 14.499C5.93862 14.1873 6.18939 13.9365 6.50109 13.9365C6.81279 13.9365 7.06356 14.1873 7.06356 14.499C7.06356 14.8083 6.81279 15.0614 6.50109 15.0614Z" fill="white"/>
          </svg>
        </span>
        <span class="of-locator-service-tag__text">${escapeHtml(serviceTagLabel)}</span>
      </div>`
      : '';

    return `<div class="panel-item${options.isNearest ? ' panel-item--nearest' : ''}" data-item='${contentJson}' data-name="${escapeHtml(v.name)}">
      <div
        class="bussiness-name"
        role="button"
        tabindex="0"
        sensorsdata-link-name="Locator Installer Detail: ${escapeHtml(v.name)}"
        aria-label="View ${escapeHtml(v.name)} details"
        data-item='${contentJson}'
      >
        <div class="panel-item-title-row">
          <h1 class="name">${escapeHtml(v.name)}</h1>
          ${nearestBadge}
        </div>
        <span class="icon-arrow" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9767 9.99988L6.85168 5.87488L8.03002 4.69656L13.3333 9.99988L8.03002 15.3032L6.85168 14.1249L10.9767 9.99988Z" fill="black" />
          </svg>
        </span>
      </div>
      <ul class="panel-item-info">
        <li class="panel-item-info__row panel-item-info__row--address">
          <span class="panel-item-info__icon panel-item-info__icon--address" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
              <path d="M6 0C9.31376 0 12 2.32004 12 6.29724C12 9.32323 8.52671 13.6925 6.86541 15.6092C6.38753 16.1408 5.58529 16.1196 5.13494 15.6092C3.474 13.6935 0 9.32389 0 6.29724C0 2.32004 2.68624 0 6 0ZM6 3.64577C5.43836 3.64577 4.89973 3.85528 4.5026 4.22822C4.10546 4.60115 3.88235 5.10696 3.88235 5.63437C3.88235 6.16178 4.10546 6.66759 4.5026 7.04053C4.89973 7.41346 5.43836 7.62297 6 7.62297C6.56164 7.62297 7.10027 7.41346 7.4974 7.04053C7.89454 6.66759 8.11765 6.16178 8.11765 5.63437C8.11765 5.10696 7.89454 4.60115 7.4974 4.22822C7.10027 3.85528 6.56164 3.64577 6 3.64577Z" fill="#747474"/>
            </svg>
          </span>
          <button
            type="button"
            class="panel-item-info__text panel-item-info__text--address"
            data-of-locator-directions
            aria-label="Get directions to ${escapeHtml(fields.address)}"
          >${escapeHtml(fields.address)}</button>
        </li>
        <li class="panel-item-info__row panel-item-info__row--distance">
          <span class="panel-item-info__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
              <path d="M9.28438 12.4835C8.45062 13.505 7.7496 14.2584 7.57279 14.4461C7.29954 14.7364 6.91377 14.9029 6.51452 14.9029C6.11527 14.9029 5.7295 14.7359 5.45625 14.4455C5.27944 14.2578 4.57686 13.5029 3.74154 12.4794C3.66895 12.3907 3.5191 12.3326 3.40607 12.3518C1.37767 12.7008 0 13.3821 0 14.165C0 15.3032 2.91038 16.2261 6.5 16.2261C10.0896 16.2261 13 15.3032 13 14.165C13 13.3852 11.6343 12.707 9.61985 12.3565C9.50682 12.3373 9.35697 12.3948 9.28438 12.4835Z" fill="#747474"/>
              <path d="M6.51425 0C3.54424 0 1.03467 2.50957 1.03467 5.47958C1.03467 8.27849 5.6276 13.2354 6.15129 13.7913C6.24514 13.8913 6.37684 13.9478 6.51373 13.9478C6.65113 13.9478 6.78232 13.8913 6.87617 13.7913C7.39986 13.2354 11.9928 8.27849 11.9928 5.47958C11.9938 2.50957 9.48425 0 6.51425 0ZM6.49921 7.87042C5.17857 7.87042 4.10838 6.7997 4.10838 5.47958C4.10838 4.15895 5.17909 3.08875 6.49921 3.08875C7.81985 3.08875 8.89005 4.15946 8.89005 5.47958C8.89005 6.80022 7.81985 7.87042 6.49921 7.87042Z" fill="#747474"/>
            </svg>
          </span>
          <span class="panel-item-info__text">${escapeHtml(fields.distance)}mi</span>
        </li>
      </ul>
      ${serviceTagHtml}
    </div>`;
  }

  function trackDealerSearchEvent(keyword, hasResult) {
    const normalizedKeyword = String(keyword || '').trim();
    if (!normalizedKeyword) return;

    try {
      const client = window.sensorsDataAnalytic201505 || window['sensorsDataAnalytic201505'];
      if (!client || typeof client.track !== 'function') return;

      client.track(hasResult ? 'DealerYesResult' : 'DealerNoResult', {
        keyword: normalizedKeyword,
      });
    } catch (error) {
      console.error('[of-locator] Dealer search track failed:', error);
    }
  }

  function createDebouncedDealerSearchTracker() {
    let timer = null;

    return function scheduleDealerSearchTrack(keyword, hasResult) {
      const normalizedKeyword = String(keyword || '').trim();
      if (!normalizedKeyword) return;

      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        trackDealerSearchEvent(normalizedKeyword, hasResult);
      }, DEALER_SEARCH_SUBMIT_DEBOUNCE_MS);
    };
  }

  function initLocator(root) {
    if (!root || root.dataset.ofLocatorInitialized === 'true') return;

    const distance = root.querySelector(OF_LOCATOR_SELECTORS.distance);
    const defIcon = root.querySelector(OF_LOCATOR_SELECTORS.defIcon);
    const selectIcon = root.querySelector(OF_LOCATOR_SELECTORS.selectIcon);
    const distanceNum = root.querySelector(OF_LOCATOR_SELECTORS.distanceNum);
    const distanceList = root.querySelector(OF_LOCATOR_SELECTORS.distanceList);
    const distanceOptions = Array.from(root.querySelectorAll(OF_LOCATOR_SELECTORS.distanceOption));
    const tagsContainer = root.querySelector(OF_LOCATOR_SELECTORS.tagsContainer);
    const tagsContainerM = root.querySelector(OF_LOCATOR_SELECTORS.tagsContainerM);
    const searchInput = root.querySelector(OF_LOCATOR_SELECTORS.searchInput);
    const searchSuggestions = root.querySelector(OF_LOCATOR_SELECTORS.searchSuggestions);
    const searchWrap = searchInput?.closest('.of-locator-search-wrap');
    const searchBtn = root.querySelector(OF_LOCATOR_SELECTORS.searchBtn);
    const myLocation = root.querySelector(OF_LOCATOR_SELECTORS.myLocation);
    const panelContainer = root.querySelector(OF_LOCATOR_SELECTORS.panelContainer);
    const mapContainer = root.querySelector(OF_LOCATOR_SELECTORS.mapContainer);

    if (!distance || !distanceList || !searchInput || !panelContainer || !mapContainer) return;

    ensureMapContainerId(root, mapContainer);

    const tabSection = root.closest('.js-of-locators-map-tab-root');
    const tabPanel = root.closest('.tab-content');
    let mapVisibilityObserver = null;
    let locatorInitStarted = false;

    function isLocatorTabPanelActive() {
      if (!tabPanel) return true;
      return tabPanel.classList.contains('is-active') && tabPanel.getAttribute('aria-hidden') !== 'true';
    }

    function activateLocatorIfNeeded(options = {}) {
      if (!isLocatorTabPanelActive()) return;
      const forceRefetch = Boolean(options.forceRefetch);

      loadGoogleMaps().then(() => {
        if (!map) {
          if (locatorInitStarted) return;
          locatorInitStarted = true;
          initMap();
          return;
        }

        refreshMapLayout(getMapLayoutCenter());

        if (forceRefetch) {
          refetchLocatorWithCurrentCenter('init');
        }
      });
    }

    function bindTabActivationListener() {
      if (!tabSection) return;

      tabSection.addEventListener('of-locator-tab-before-deactivate', (event) => {
        const panel = event.detail?.previousPanel;
        if (panel && !panel.contains(root)) return;

        tabSection.__ofLocatorSharedFilters = getCurrentLocatorFilters();
        event.detail.locatorFiltersSynced = true;
      });

      tabSection.addEventListener('of-locator-tab-activate', (event) => {
        if (!event.detail?.fromUserClick) return;

        const panel = event.detail.panel;
        if (panel && !panel.contains(root)) return;

        if (event.detail.syncFilters && applySharedLocatorFilters()) return;

        activateLocatorIfNeeded({ forceRefetch: true });
      });
    }

    let resolvedDefaultLatLng = null;
    let defaultLatLngPromise = null;

    function getFallbackLatLng() {
      return resolvedDefaultLatLng || DEFAULT_LAT_LNG;
    }

    function ensureDefaultLatLng() {
      if (!defaultLatLngPromise) {
        defaultLatLngPromise = geocodeSiteCountryCenter(root).then((lngLat) => {
          resolvedDefaultLatLng = lngLat;
          return lngLat;
        });
      }

      return defaultLatLngPromise;
    }

    const distanceLabel = distance.querySelector('.text span:first-child');
    const defaultDistanceLabel = distanceLabel ? distanceLabel.textContent : '';
    let map = null;
    let markers = {};
    let infowindows = {};
    let activeInfoId = null;
    let locationPermission = true;
    let pos = { lng: null, lat: null };
    let lastGeolocationPos = null;
    let installerSearchCache = [];
    let installerSuggestionCache = [];
    let installerSuggestionsFetchStarted = false;
    let suggestionMatches = [];
    let googlePredictions = [];
    let suggestionMode = null;
    let searchInputDebounceTimer = null;
    let autocompleteService = null;
    let placesService = null;
    let placesSessionToken = null;
    let googlePredictionsRequestId = 0;
    let mapInitPromise = null;
    let lastBackHeaderAt = 0;
    let addressSearchActive = false;
    let lastGeocodedCountry = null;
    let myLocationSearchActive = false;
    let activeDetailCenter = null;
    let mapLayoutRefreshId = 0;
    let detailMapMarker = null;
    let detailInfoWindow = null;
    let lastPanelNoticeType = null;
    const scheduleDealerSearchTrack = createDebouncedDealerSearchTracker();

    function setDistanceLabel(value) {
      if (!distanceLabel) return;
      const text = String(value || '').trim();
      distanceLabel.textContent = text || defaultDistanceLabel;
      if (distanceNum) distanceNum.textContent = '';
      distance.classList.toggle('of-locator-distance-selected', Boolean(text));
    }

    function renderTags(tag) {
      const ret = `<div class="tag-item"><span class="tag-miles">${escapeHtml(tag)}</span><svg class="icon-del" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99999 7.05732L11.3 3.75732L12.2427 4.69999L8.94266 7.99999L12.2427 11.3L11.3 12.2427L7.99999 8.94266L4.69999 12.2427L3.75732 11.3L7.05732 7.99999L3.75732 4.69999L4.69999 3.75732L7.99999 7.05732Z" fill="#808080" /></svg></div>`;
      if (tagsContainer) tagsContainer.innerHTML = ret;
      if (tagsContainerM) tagsContainerM.innerHTML = ret;
    }

    function getDistance() {
      const tag = tagsContainer?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      const tagM = tagsContainerM?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      const source = document.documentElement.clientWidth > 860 ? tag : tagM;
      const distance = source ? parseFloat(source.textContent) : 10000;
      return Number.isNaN(distance) ? 10000 : distance;
    }

    function clearDistance() {
      if (tagsContainer) tagsContainer.innerHTML = '';
      if (tagsContainerM) tagsContainerM.innerHTML = '';
      distance.classList.remove('active');
      if (defIcon) defIcon.style.display = 'block';
      if (selectIcon) selectIcon.style.display = 'none';
      if (distanceNum) distanceNum.textContent = '';
      distanceOptions.forEach((option) => {
        option.style.fontWeight = '400';
      });
      setDistanceLabel('');
    }

    function getSelectedDistanceTagText() {
      const tag = tagsContainer?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      const tagM = tagsContainerM?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      return String((tag || tagM)?.textContent || '').trim();
    }

    function setDistanceFilter(tag) {
      const value = String(tag || '').trim();
      if (!value) {
        clearDistance();
        return;
      }

      renderTags(value);
      setDistanceLabel(value);
      distance.classList.add('active');
      distanceList.style.display = 'none';
      if (defIcon) defIcon.style.display = 'none';
      if (selectIcon) selectIcon.style.display = 'block';
      if (distanceNum) distanceNum.textContent = '';
      distanceOptions.forEach((option) => {
        option.style.fontWeight = option.textContent.trim() === value ? '500' : '400';
      });
    }

    function getCurrentLocatorFilters() {
      return {
        searchValue: searchInput.value,
        distanceTag: getSelectedDistanceTagText(),
        position: hasActivePosition() ? { lat: Number(pos.lat), lng: Number(pos.lng) } : null,
        addressSearchActive,
        lastGeocodedCountry,
        myLocationSearchActive,
      };
    }

    function applySharedLocatorFilters() {
      const filters = tabSection?.__ofLocatorSharedFilters;
      if (!filters) return false;

      searchInput.value = String(filters.searchValue || '');
      setDistanceFilter(filters.distanceTag);
      hideSearchSuggestions();

      addressSearchActive = Boolean(filters.addressSearchActive);
      lastGeocodedCountry = filters.lastGeocodedCountry || null;
      myLocationSearchActive = Boolean(filters.myLocationSearchActive);

      const sharedPosition = parseLatLng(filters.position?.lat, filters.position?.lng);
      if (sharedPosition) {
        pos = sharedPosition;
      }

      loadGoogleMaps().then(() => {
        if (!isLocatorTabPanelActive()) return;

        if (!map) {
          initMap('init', {
            useGeolocation: false,
            useCurrentPosition: Boolean(sharedPosition),
          });
          return;
        }

        if (sharedPosition) {
          applyLocatorCenter(sharedPosition, 'init');
          return;
        }

        if (searchInput.value.trim()) {
          handleSearch();
          return;
        }

        refetchLocatorWithCurrentCenter('init');
      });

      return true;
    }

    function clearDetailMapOverlay() {
      if (detailInfoWindow) {
        detailInfoWindow.close();
        detailInfoWindow = null;
      }

      if (detailMapMarker) {
        detailMapMarker.setMap(null);
        detailMapMarker = null;
      }
    }

    function clearMarkers() {
      Object.keys(markers).forEach((id) => {
        markers[id].setMap(null);
      });
      markers = {};
      infowindows = {};
      activeInfoId = null;
    }

    function getSelectedDistanceDisplay() {
      const tag = tagsContainer?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      const tagM = tagsContainerM?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      const source = document.documentElement.clientWidth > 860 ? tag : tagM;

      if (!source) return '';

      const selectedText = distanceLabel ? distanceLabel.textContent.trim() : '';
      if (selectedText && selectedText !== defaultDistanceLabel) {
        return selectedText.replace(/\s+/g, '');
      }

      return source.textContent.trim();
    }

    function hasLimitedDistanceFilter() {
      return getDistance() < 10000;
    }

    function hasAddressSearchContext() {
      return addressSearchActive || searchInput.value.trim() !== '';
    }

    function hasActivePosition() {
      return (
        pos?.lat != null &&
        pos?.lng != null &&
        !Number.isNaN(Number(pos.lat)) &&
        !Number.isNaN(Number(pos.lng))
      );
    }

    function rememberGeolocationPosition(lngLat) {
      const saved = parseLatLng(lngLat?.lat, lngLat?.lng);
      if (saved) lastGeolocationPos = saved;
    }

    function hasDistanceFilterSelected() {
      const tag = tagsContainer?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      const tagM = tagsContainerM?.querySelector(OF_LOCATOR_SELECTORS.tagMiles);
      const source = document.documentElement.clientWidth > 860 ? tag : tagM;
      return Boolean(source?.textContent?.trim());
    }

    function parseResponseEmptyInRange(res, items, requestedDistance) {
      if (requestedDistance >= 10000) return false;

      const flagKeys = [
        'emptyInRange',
        'inRangeEmpty',
        'outOfRange',
        'outOfRangeFallback',
        'hasNearestOutsideRange',
        'dataEmptyInRange',
      ];

      if (
        flagKeys.some((key) => {
          const value = res[key];
          return value === true || value === 1 || value === '1';
        })
      ) {
        return true;
      }

      if (!items.length) return true;

      return items.every((item) => {
        const distanceValue = parseFloat(item.distance);
        return !Number.isNaN(distanceValue) && distanceValue > requestedDistance;
      });
    }

    function getSiteCountryDisplayName() {
      return (
        root.dataset.siteCountryLabel ||
        root.dataset.siteCountry ||
        window.renogyConfig?.country ||
        ''
      );
    }

    function getSiteCountryMatchers() {
      const site = normalizeLocatorSiteCountry(
        root.dataset.siteCountry || window.renogyConfig?.country || ''
      );
      return SITE_COUNTRY_MATCHERS[site] || { codes: [site], names: [] };
    }

    function isAddressInSiteCountry(geocodedCountry) {
      if (!geocodedCountry?.code && !geocodedCountry?.name) return true;

      const matchers = getSiteCountryMatchers();
      const code = normalizeCountryToken(geocodedCountry.code);
      const name = String(geocodedCountry.name || '').trim().toLowerCase();

      if (matchers.codes.some((matcherCode) => normalizeCountryToken(matcherCode) === code)) {
        return true;
      }

      return matchers.names.some((matcherName) => name === matcherName.toLowerCase());
    }

    function parseResponseCountryMismatch(res) {
      if (!res) return false;

      const flagKeys = [
        'countryMismatch',
        'outOfSiteCountry',
        'wrongCountry',
        'invalidCountry',
        'notInSiteCountry',
      ];

      if (
        flagKeys.some((key) => {
          const value = res[key];
          return value === true || value === 1 || value === '1';
        })
      ) {
        return true;
      }

      const message = String(res.message || res.msg || '');
      if (/不属于|does not belong|not belong|wrong country|outside.*country/i.test(message)) {
        return true;
      }

      const mismatchCodes = new Set(['100001', '100002', 'COUNTRY_MISMATCH', 'SITE_COUNTRY_MISMATCH']);
      return mismatchCodes.has(String(res.code || ''));
    }

    function isCountryMismatch(res) {
      if (parseResponseCountryMismatch(res)) return true;
      if (!lastGeocodedCountry) return false;
      return !isAddressInSiteCountry(lastGeocodedCountry);
    }

    function buildCountryMismatchMessage() {
      const country = getSiteCountryDisplayName();
      const template =
        root.dataset.countryMismatchMessage ||
        'The address you provided is not in {country}. Please select the matching country in the country selector and search again.';
      return template.replace(/\{country\}/g, country);
    }

    function buildEmptyRangeMessage() {
      const distanceText = getSelectedDistanceDisplay();
      const template =
        root.dataset.emptyRangeMessage ||
        'Within {distance} of your address, no dealers/installers were found. Showing the nearest one for you.';
      return template.replace(/\{distance\}/g, distanceText);
    }

    function buildPanelNoticeMessage(noticeType) {
      if (noticeType === 'country-mismatch') return buildCountryMismatchMessage();
      if (noticeType === 'empty-in-range') return buildEmptyRangeMessage();
      return '';
    }

    function shouldShowEmptyRangeNotice() {
      if (hasAddressSearchContext()) return true;
      return hasLimitedDistanceFilter() && hasDistanceFilterSelected();
    }

    function resolveNoticeType(searchResult) {
      const { items, emptyInRange, countryMismatch, res } = searchResult;

      if (
        myLocationSearchActive &&
        lastGeocodedCountry &&
        !isAddressInSiteCountry(lastGeocodedCountry)
      ) {
        return 'country-mismatch';
      }

      const mismatch = countryMismatch || isCountryMismatch(res);
      const noResults = emptyInRange || items.length === 0;

      if (hasAddressSearchContext() && mismatch) {
        return 'country-mismatch';
      }

      if (hasActivePosition() && noResults && shouldShowEmptyRangeNotice()) {
        return 'empty-in-range';
      }

      return null;
    }

    function buildBusinessListHtml(data) {
      const nearestId = getNearestItemId(data);
      const nearestLabel = root.dataset.nearestLabel || 'Nearest';
      const serviceTagLabel = root.dataset.serviceTagLabel || 'Offers installation services';

      return (
        data
          .map((item) =>
            buildPanelItem(item, {
              isNearest: nearestId != null && item.id === nearestId,
              nearestLabel,
              serviceTagLabel,
            })
          )
          .join('')
      );
    }

    function renderBusinessList(data, state, options = {}) {
      const slideClass = state === 'init' ? '' : ' slide';
      const noticeType = options.noticeType || null;
      const noticeClass = noticeType ? ' panel-list--has-notice' : '';

      if (noticeType) {
        const notice = buildPanelNoticeMessage(noticeType);
        const listHtml = data.length ? buildBusinessListHtml(data) : '';
        const noticeModifier =
          noticeType === 'country-mismatch'
            ? ' of-locator-panel-notice--country-mismatch'
            : ' of-locator-panel-notice--empty-range';
        panelContainer.innerHTML = `<div class="panel-list${noticeClass}${slideClass}">
          <p class="of-locator-panel-notice${noticeModifier}">${escapeHtml(notice)}</p>
          ${listHtml}
        </div>`;
        return;
      }

      const listHtml = buildBusinessListHtml(data);
      panelContainer.innerHTML = `<div class="panel-list${slideClass}">${listHtml || ''}</div>`;
    }

    function renderPanelNotice(noticeType, state, data = []) {
      renderBusinessList(data, state, { noticeType });
    }

    function createPanelMarkers(dataNew) {
      clearMarkers();

      dataNew.forEach((v) => {
        const latLng = parseLatLng(v.latitude, v.longitude);
        if (!latLng) return;

        const marker = new google.maps.Marker({
          position: latLng,
          map,
          title: v.name,
        });

        marker.addListener('click', () => {
          renderBusinessDetail(v);
        });

        markers[v.id] = marker;
      });
    }

    function createPanel(data, state, options = {}) {
      const dataNew = data.filter((v) => v.referId);
      const noticeType = options.noticeType || null;
      lastPanelNoticeType = noticeType;
      renderBusinessList(dataNew, state, { noticeType });
      createPanelMarkers(dataNew);
    }

    function getRequestServerType() {
      const configuredType = String(
        root.dataset.serverType || root.getAttribute('data-server-type') || ''
      ).trim();
      if (configuredType) {
        return configuredType;
      }

      const tabTitle = String(root.dataset.locatorTabTitle || '').trim();
      if (tabTitle === 'Authorized Installer') {
        return 'Authorized Installer';
      }
      if (tabTitle === 'Retail Stores' || tabTitle === 'Retail Store') {
        return 'Retail Store';
      }

      const serviceTypeEl = root.querySelector(OF_LOCATOR_SELECTORS.serviceType);
      const type = serviceTypeEl ? serviceTypeEl.textContent.trim() : '';
      return type === 'All Types' || type === 'Service Type' ? '' : type;
    }

    function requestInstallerSearch(lngLat, distanceValue) {
      if (!isLocatorTabPanelActive()) {
        return Promise.resolve({
          items: [],
          emptyInRange: false,
          countryMismatch: false,
          res: null,
        });
      }

      const serverType = getRequestServerType();

      return getIpCountry().then((ipData) => {
        const country = resolveLocatorCountryCode(ipData, root);
        const site = getRequestSite(root);

        // https://officialweb.renogy-dchome.com/installer/search
        return fetch('https://officialweb.renogy-dchome.com/installer/v2/search', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            distance: distanceValue,
            latitude: lngLat.lat,
            longitude: lngLat.lng,
            serverType,
            country,
            site
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Installer search failed with status ${response.status}`);
            }
            return response.json();
          })
          .then((res) => {
            const countryMismatch = parseResponseCountryMismatch(res);

            if (res.code !== '000000') {
              return {
                items: [],
                emptyInRange: false,
                countryMismatch,
                res,
              };
            }

            const items = parseInstallerSearchData(res.data).filter((item) => item.referId);
            return {
              items,
              emptyInRange: parseResponseEmptyInRange(res, items, distanceValue),
              countryMismatch,
              res,
            };
          })
          .catch((error) => {
            console.error('Installer search request failed:', error);
            return {
              items: [],
              emptyInRange: false,
              countryMismatch: false,
              res: null,
            };
          });
      });
    }

    function refreshInstallerSuggestions(lngLat) {
      if (installerSuggestionsFetchStarted) return;

      const requestCenter = parseLatLng(lngLat?.lat, lngLat?.lng);
      if (!requestCenter || !isLocatorTabPanelActive()) return;

      installerSuggestionsFetchStarted = true;

      requestInstallerSearch(requestCenter, INSTALLER_SUGGESTION_SEARCH_DISTANCE).then((searchResult) => {
        installerSuggestionCache = searchResult.items || [];

        const query = searchInput?.value.trim();
        if (query) {
          updateSearchSuggestions();
        }
      });
    }

    function getInstallerSuggestionSource() {
      return installerSuggestionCache.length ? installerSuggestionCache : installerSearchCache;
    }

    function fetchData(state, lngLat) {
      if (!isLocatorTabPanelActive()) return;

      const requestCenter = parseLatLng(lngLat?.lat, lngLat?.lng) || (hasActivePosition() ? pos : null);
      if (!requestCenter) return;

      pos = requestCenter;
      refreshInstallerSuggestions(requestCenter);

      const distance = getDistance();
      const trackKeyword = searchInput?.value.trim() || '';

      requestInstallerSearch(requestCenter, distance).then((searchResult) => {
        const { items } = searchResult;
        installerSearchCache = items;
        let noticeType = resolveNoticeType(searchResult);

        if (trackKeyword && addressSearchActive) {
          scheduleDealerSearchTrack(trackKeyword, items.length > 0);
        }

        if (!noticeType && items.length === 0 && hasActivePosition() && shouldShowEmptyRangeNotice()) {
          noticeType = 'empty-in-range';
        }

        if (noticeType && items.length === 0) {
          renderPanelNotice(noticeType, state, []);
          clearMarkers();
          return;
        }

        createPanel(items, state, { noticeType: noticeType || null });
      });
    }

    function removeGooglePacContainers() {
      if (!searchWrap) return;
      const scope = searchWrap.closest('.installer-locator-container') || root;
      scope.querySelectorAll('.pac-container').forEach((node) => node.remove());
    }

    function initPlacesServices() {
      if (!window.google?.maps?.places) return;

      if (!autocompleteService) {
        autocompleteService = new google.maps.places.AutocompleteService();
      }

      if (!placesService) {
        placesService = new google.maps.places.PlacesService(map || mapContainer);
      }
    }

    function fetchGooglePredictions(query) {
      return new Promise((resolve) => {
        if (!autocompleteService || !query) {
          resolve([]);
          return;
        }

        if (!placesSessionToken) {
          placesSessionToken = new google.maps.places.AutocompleteSessionToken();
        }

        autocompleteService.getPlacePredictions(
          {
            input: query,
            sessionToken: placesSessionToken,
          },
          (predictions, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions?.length) {
              resolve([]);
              return;
            }
            resolve(predictions.slice(0, INSTALLER_SEARCH_SUGGESTION_LIMIT));
          }
        );
      });
    }

    function hideSearchSuggestions() {
      if (!searchSuggestions) return;
      searchSuggestions.hidden = true;
      searchSuggestions.innerHTML = '';
      suggestionMatches = [];
      googlePredictions = [];
      suggestionMode = null;
      googlePredictionsRequestId += 1;
      root.classList.remove('is-local-search-active', 'is-google-search-active');
      removeGooglePacContainers();
      if (searchInput) {
        searchInput.setAttribute('aria-expanded', 'false');
        searchInput.removeAttribute('aria-activedescendant');
      }
    }

    function renderSuggestionList(html) {
      if (!searchSuggestions) return;

      const listId = `${root.dataset.locatorInstanceId || 'of-locator'}-search-suggestions`;
      searchSuggestions.id = listId;
      if (searchInput) {
        searchInput.setAttribute('aria-controls', listId);
        searchInput.setAttribute('aria-expanded', 'true');
      }

      searchSuggestions.innerHTML = html;
      searchSuggestions.hidden = false;
      removeGooglePacContainers();
    }

    function showSearchSuggestions(matches) {
      googlePredictionsRequestId += 1;
      suggestionMode = 'local';
      googlePredictions = [];
      root.classList.remove('is-google-search-active');
      root.classList.add('is-local-search-active');

      suggestionMatches = matches.slice(0, INSTALLER_SEARCH_SUGGESTION_LIMIT);
      if (!suggestionMatches.length) {
        hideSearchSuggestions();
        return;
      }

      const listId = `${root.dataset.locatorInstanceId || 'of-locator'}-search-suggestions`;
      renderSuggestionList(
        suggestionMatches
          .map((item, index) => {
            const address = String(item.address || '').trim();
            return `<button
              type="button"
              class="of-locator-search-suggestion"
              role="option"
              id="${listId}-option-${index}"
              data-suggestion-mode="local"
              data-suggestion-index="${index}"
            >
              <span class="of-locator-search-suggestion__name">${escapeHtml(item.name || '')}</span>
              ${address ? `<span class="of-locator-search-suggestion__address">${escapeHtml(address)}</span>` : ''}
            </button>`;
          })
          .join('')
      );
    }

    function showGoogleSuggestions(predictions) {
      suggestionMode = 'google';
      suggestionMatches = [];
      root.classList.remove('is-local-search-active');
      root.classList.add('is-google-search-active');

      googlePredictions = predictions.slice(0, INSTALLER_SEARCH_SUGGESTION_LIMIT);
      if (!googlePredictions.length) {
        hideSearchSuggestions();
        return;
      }

      const listId = `${root.dataset.locatorInstanceId || 'of-locator'}-search-suggestions`;
      renderSuggestionList(
        googlePredictions
          .map((prediction, index) => {
            const mainText = prediction.structured_formatting?.main_text || prediction.description || '';
            const secondaryText = prediction.structured_formatting?.secondary_text || '';
            return `<button
              type="button"
              class="of-locator-search-suggestion of-locator-search-suggestion--google"
              role="option"
              id="${listId}-google-option-${index}"
              data-suggestion-mode="google"
              data-google-index="${index}"
            >
              <span class="of-locator-search-suggestion__name">${escapeHtml(mainText)}</span>
              ${secondaryText ? `<span class="of-locator-search-suggestion__address">${escapeHtml(secondaryText)}</span>` : ''}
            </button>`;
          })
          .join('')
      );
    }

    function selectGooglePrediction(prediction) {
      if (!prediction?.place_id) return;

      hideSearchSuggestions();

      ensureMapReady().then(() => {
        initPlacesServices();
        if (!placesService) return;

        placesService.getDetails(
          {
            placeId: prediction.place_id,
            fields: ['geometry', 'formatted_address', 'name', 'address_components'],
            sessionToken: placesSessionToken,
          },
          (place, status) => {
            placesSessionToken = new google.maps.places.AutocompleteSessionToken();

            if (status !== google.maps.places.PlacesServiceStatus.OK || !place?.geometry?.location) {
              handleGoogleSearch(prediction.description);
              return;
            }

            applySearchPosition(
              {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
              },
              place.formatted_address || prediction.description,
              extractCountryFromPlace(place)
            );
          }
        );
      });
    }

    function updateSearchSuggestions() {
      const query = searchInput.value.trim();
      if (!query) {
        hideSearchSuggestions();
        return;
      }

      const localMatches = filterInstallers(query, getInstallerSuggestionSource());
      if (localMatches.length > 0) {
        showSearchSuggestions(localMatches);
        scheduleDealerSearchTrack(query, true);
        return;
      }

      const requestId = ++googlePredictionsRequestId;

      fetchGooglePredictions(query).then((predictions) => {
        if (requestId !== googlePredictionsRequestId) return;

        const currentQuery = searchInput.value.trim();
        if (currentQuery !== query) return;

        const localAgain = filterInstallers(currentQuery, getInstallerSuggestionSource());
        if (localAgain.length > 0) {
          showSearchSuggestions(localAgain);
          scheduleDealerSearchTrack(currentQuery, true);
          return;
        }

        if (predictions.length > 0) {
          showGoogleSuggestions(predictions);
          scheduleDealerSearchTrack(currentQuery, true);
        } else {
          hideSearchSuggestions();
          scheduleDealerSearchTrack(currentQuery, false);
        }
      });
    }

    function ensureMapReady() {
      return loadGoogleMaps().then(() => {
        if (map) return map;

        if (!mapInitPromise) {
          mapInitPromise = Promise.resolve().then(() => {
            initMap('search');
            mapInitPromise = null;
            return map;
          });
        }

        return mapInitPromise;
      });
    }

    function applySearchPosition(latLng, label, geocodedCountry = null) {
      if (!latLng || Number.isNaN(latLng.lat) || Number.isNaN(latLng.lng)) return;

      myLocationSearchActive = false;
      addressSearchActive = true;
      if (geocodedCountry) {
        lastGeocodedCountry = geocodedCountry;
      }
      if (label && searchInput) searchInput.value = label;
      pos = latLng;

      if (map) {
        map.setCenter(pos);
        map.setZoom(10);
        refreshMapLayout(pos);
      }

      fetchData('init', pos);
    }

    function selectInstallerFromSearch(item, matchedList) {
      hideSearchSuggestions();
      const keyword = searchInput.value.trim() || item?.name || item?.address || '';
      if (keyword) {
        scheduleDealerSearchTrack(keyword, true);
      }
      if (!item?.referId || !map || !window.google?.maps) return;

      const lat = Number(item.latitude);
      const lng = Number(item.longitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return;

      searchInput.value = item.name || item.address || searchInput.value;
      pos = { lat, lng };
      map.setCenter(pos);
      map.setZoom(12);
      refreshMapLayout(pos);

      const panelData = matchedList?.length ? matchedList : [item];
      createPanel(panelData, 'init');
    }

    function handleGoogleSearch(query) {
      const address = String(query || searchInput.value || '').trim();
      if (!address) return;

      hideSearchSuggestions();

      ensureMapReady().then(() => {
        if (!window.google?.maps) return;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
          if (status !== 'OK' || !results?.length) {
            console.log('Geocode failed:', status);
            scheduleDealerSearchTrack(address, false);
            return;
          }

          const location = results[0].geometry.location;
          applySearchPosition(
            {
              lat: location.lat(),
              lng: location.lng(),
            },
            results[0].formatted_address || address,
            extractCountryFromGeocoderResult(results[0])
          );
        });
      });
    }

    function runLocalSearch(query, options = {}) {
      const matches = filterInstallers(query, getInstallerSuggestionSource());
      if (matches.length > 0) {
        if (
          options.selectFirstOnEnter &&
          suggestionMode === 'local' &&
          suggestionMatches.length > 0
        ) {
          selectInstallerFromSearch(suggestionMatches[0], suggestionMatches);
          return true;
        }
        showSearchSuggestions(matches);
        if (options.reportSubmitResult) {
          scheduleDealerSearchTrack(query, true);
        }
        return true;
      }

      return false;
    }

    function performSearchSubmit(query) {
      ensureMapReady().then(() => {
        initPlacesServices();

        if (runLocalSearch(query, { selectFirstOnEnter: true, reportSubmitResult: true })) return;

        if (suggestionMode === 'google' && googlePredictions.length > 0) {
          selectGooglePrediction(googlePredictions[0]);
          return;
        }

        handleGoogleSearch(query);
      });
    }

    function handleSearch() {
      const query = searchInput.value.trim();
      if (!query) return;
      addressSearchActive = true;
      performSearchSubmit(query);
    }

    function applyLocatorCenter(lngLat, state = 'init') {
      if (!lngLat || Number.isNaN(lngLat.lat) || Number.isNaN(lngLat.lng)) return;

      pos = lngLat;
      if (map) {
        map.setCenter(lngLat);
        map.setZoom(10);
        refreshMapLayout(lngLat);
      }
      fetchData(state, lngLat);
    }

    function loadWithSiteDefaultCenter(state = 'init') {
      return ensureDefaultLatLng().then((fallbackLatLng) => applyLocatorCenter(fallbackLatLng, state));
    }

    function getDistanceFilterCenter(fallbackLatLng) {
      if (hasActivePosition()) {
        return pos;
      }

      return fallbackLatLng;
    }

    function refetchLocatorWithCurrentCenter(state = 'init') {
      if (hasActivePosition()) {
        fetchData(state, pos);
        return Promise.resolve();
      }

      return ensureDefaultLatLng().then((fallbackLatLng) => {
        applyLocatorCenter(fallbackLatLng, state);
      });
    }

    function restoreLocatorToMyLocation(state = 'init') {
      ensureMapReady().then(() => {
        if (lastGeolocationPos) {
          applyLocatorCenter(lastGeolocationPos, state);
          return;
        }

        if (navigator.geolocation && locationPermission) {
          ensureDefaultLatLng().then((fallbackLatLng) => {
            useMyLocation(state, fallbackLatLng);
          });
          return;
        }

        if (hasActivePosition()) {
          refetchLocatorWithCurrentCenter(state);
          return;
        }

        loadWithSiteDefaultCenter(state);
      });
    }

    function handleSearchInput() {
      window.clearTimeout(searchInputDebounceTimer);
      removeGooglePacContainers();

      const query = searchInput.value.trim();
      if (!query) {
        addressSearchActive = false;
        lastGeocodedCountry = null;
        myLocationSearchActive = false;
        hideSearchSuggestions();
        googlePredictionsRequestId += 1;
        restoreLocatorToMyLocation('init');
        return;
      }

      const localMatches = filterInstallers(query, getInstallerSuggestionSource());
      if (localMatches.length > 0) {
        googlePredictionsRequestId += 1;
        showSearchSuggestions(localMatches);
        scheduleDealerSearchTrack(query, true);
        return;
      }

      hideSearchSuggestions();

      myLocationSearchActive = false;

      searchInputDebounceTimer = window.setTimeout(() => {
        ensureMapReady().then(() => {
          initPlacesServices();
          updateSearchSuggestions();
        });
      }, INSTALLER_SEARCH_INPUT_DEBOUNCE_MS);
    }

    function runInitialLocationSearch(state, fallbackLatLng) {
      useMyLocation(state, fallbackLatLng);
    }

    function applySiteDefaultCenter(state, defaultLatLng) {
      map.setCenter(defaultLatLng);
      map.setZoom(10);
      refreshMapLayout(defaultLatLng);
      fetchData(state, defaultLatLng);
    }

    function applyPositionIfInSiteCountry(latLng, state) {
      if (!window.google?.maps?.Geocoder) {
        myLocationSearchActive = false;
        applyLocatorCenter(latLng, state);
        return;
      }

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latLng }, (results, status) => {
        const country = status === 'OK' && results?.length
          ? extractCountryFromGeocoderResult(results[0])
          : null;
        const siteCountry = getSiteCountryCode(root);

        if (country?.code && !isCountryMatchingSite(country.code, siteCountry)) {
          myLocationSearchActive = true;
          lastGeocodedCountry = country;
          pos = latLng;
          rememberGeolocationPosition(latLng);
          if (map) {
            map.setCenter(latLng);
            map.setZoom(10);
            refreshMapLayout(latLng);
          }
          fetchData(state, latLng);
          locationPermission = true;
          return;
        }

        myLocationSearchActive = false;
        pos = latLng;
        rememberGeolocationPosition(latLng);
        if (map) {
          map.setCenter(latLng);
          map.setZoom(10);
          refreshMapLayout(latLng);
        }
        fetchData(state, latLng);
        locationPermission = true;
      });
    }

    function useMyLocation(state, defaultLatLng) {
      if (!navigator.geolocation) {
        myLocationSearchActive = false;
        applySiteDefaultCenter(state, defaultLatLng);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          applyPositionIfInSiteCountry(
            {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
            state
          );
        },
        (err) => {
          if (err.code === err.PERMISSION_DENIED) {
            locationPermission = false;
          }

          myLocationSearchActive = false;
          applySiteDefaultCenter(state, defaultLatLng);
        }
      );
    }

    function getMapLayoutCenter(preferredCenter) {
      return (
        preferredCenter ||
        activeDetailCenter ||
        (hasActivePosition() ? pos : null) ||
        getFallbackLatLng()
      );
    }

    function refreshMapLayout(center) {
      if (!map || !window.google?.maps) return;

      mapLayoutRefreshId += 1;
      const refreshId = mapLayoutRefreshId;

      const resize = () => {
        if (refreshId !== mapLayoutRefreshId || !map) return;

        google.maps.event.trigger(map, 'resize');
        const nextCenter = getMapLayoutCenter(center);
        if (nextCenter) {
          map.setCenter(nextCenter);
        }
      };

      window.requestAnimationFrame(resize);
      window.setTimeout(resize, 80);
      window.setTimeout(resize, 240);
      window.setTimeout(resize, 600);
    }

    function restoreListViewFromDetail() {
      mapLayoutRefreshId += 1;
      activeDetailCenter = null;
      clearDetailMapOverlay();

      if (!map || !window.google?.maps) return;

      const restoreCenter = hasActivePosition() ? pos : getFallbackLatLng();

      if (installerSearchCache.length) {
        createPanel(installerSearchCache, 'back', { noticeType: lastPanelNoticeType });
        map.setCenter(restoreCenter);
        map.setZoom(10);
        refreshMapLayout(restoreCenter);
        return;
      }

      if (hasActivePosition()) {
        fetchData('back', pos);
        return;
      }

      ensureDefaultLatLng().then((fallbackLatLng) => {
        applyLocatorCenter(fallbackLatLng, 'back');
      });
    }

    function handleBackHeader() {
      const now = Date.now();
      if (now - lastBackHeaderAt < BACK_HEADER_DEBOUNCE_MS) return;
      lastBackHeaderAt = now;
      restoreListViewFromDetail();
    }

    function initMap(state = 'init', options = {}) {
      if (!isLocatorTabPanelActive()) return;

      const preferGeolocation =
        options.useGeolocation !== undefined
          ? Boolean(options.useGeolocation)
          : state === 'init';

      ensureDefaultLatLng().then((fallbackLatLng) => {
        map = new google.maps.Map(mapContainer, {
          zoom: preferGeolocation ? 2 : 10,
          center: fallbackLatLng,
        });
        refreshMapLayout(fallbackLatLng);
        placesService = new google.maps.places.PlacesService(map);
        initPlacesServices();

        if (options.useCurrentPosition && hasActivePosition()) {
          applyLocatorCenter(pos, state);
          return;
        }

        if (state === 'search') return;

        if (searchInput.value.trim() !== '') {
          handleSearch();
          return;
        }

        if (preferGeolocation) {
          runInitialLocationSearch(state, fallbackLatLng);
          return;
        }

        applyLocatorCenter(fallbackLatLng, state);
      });
    }

    function renderBusinessDetail(item) {
      const detail = normalizeDetail(item);
      const dealerCenter = parseLatLng(detail.latitude, detail.longitude);

      panelContainer.innerHTML = buildBusinessDetailHtml(detail, {
        certifiedIconUrl: root.dataset.certifiedIconUrl,
        certifiedLabel: root.dataset.certifiedLabel,
      });

      const lngLat = dealerCenter || getFallbackLatLng();
      activeDetailCenter = lngLat;

      if (!map || !window.google?.maps) return;

      mapLayoutRefreshId += 1;
      clearDetailMapOverlay();
      clearMarkers();

      map.setCenter(lngLat);
      map.setZoom(12);
      refreshMapLayout(lngLat);

      detailMapMarker = new google.maps.Marker({
        position: lngLat,
        map,
        title: detail.name,
      });

      if (SHOW_BUSINESS_INFO_WINDOW) {
        detailInfoWindow = new google.maps.InfoWindow({
          content: buildBusinessInfoHtml(detail.name, detail.distance, detail),
          ariaLabel: detail.name,
        });
        detailInfoWindow.open({ anchor: detailMapMarker, map });
        detailMapMarker.addListener('click', () => {
          detailInfoWindow.open({ anchor: detailMapMarker, map });
        });
      }
    }

    function bindEvents() {
      distance.addEventListener('click', () => {
        distanceList.style.display = distanceList.style.display === 'block' ? 'none' : 'block';
      });

      distanceOptions.forEach((item) => {
        item.addEventListener('click', () => {
          const val = item.textContent;
          renderTags(val);
          setDistanceLabel(val);
          distance.classList.add('active');
          if (defIcon) defIcon.style.display = 'none';
          if (selectIcon) selectIcon.style.display = 'block';
          if (distanceNum) distanceNum.textContent = '';
          distanceOptions.forEach((option) => {
            option.style.fontWeight = '400';
          });
          item.style.fontWeight = '500';

          ensureMapReady().then(() => {
            if (!map) {
              initMap();
              return;
            }

            refetchLocatorWithCurrentCenter('init');
          });
        });
      });

      [tagsContainer, tagsContainerM].forEach((container) => {
        if (!container) return;
        container.addEventListener('click', (event) => {
          if (!event.target.matches('.icon-del')) return;
          clearDistance();
          refetchLocatorWithCurrentCenter('init');
        });
      });

      if (searchBtn) searchBtn.addEventListener('click', handleSearch);

      if (searchInput) {
        searchInput.addEventListener('input', handleSearchInput);
        searchInput.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            hideSearchSuggestions();
            return;
          }
          if (event.key !== 'Enter') return;
          event.preventDefault();
          handleSearch();
        });
      }

      if (searchSuggestions) {
        searchSuggestions.addEventListener('click', (event) => {
          const option = event.target.closest('.of-locator-search-suggestion');
          if (!option) return;
          event.preventDefault();

          if (option.dataset.suggestionMode === 'google') {
            const googleIndex = Number.parseInt(option.dataset.googleIndex, 10);
            const prediction = googlePredictions[googleIndex];
            if (prediction) {
              addressSearchActive = true;
              selectGooglePrediction(prediction);
            }
            return;
          }

          const index = Number.parseInt(option.dataset.suggestionIndex, 10);
          const item = suggestionMatches[index];
          if (item) {
            addressSearchActive = true;
            selectInstallerFromSearch(item, suggestionMatches);
          }
        });
      }

      if (searchWrap) {
        searchWrap.addEventListener('focusout', (event) => {
          if (searchWrap.contains(event.relatedTarget)) return;
          window.setTimeout(hideSearchSuggestions, 150);
        });
      }

      if (myLocation) {
        myLocation.addEventListener('click', () => {
          addressSearchActive = false;
          lastGeocodedCountry = null;
          myLocationSearchActive = false;
          searchInput.value = '';
          hideSearchSuggestions();
          if (!locationPermission) {
            const showLocationBlockedDialog = () => {
              const host = window.location.hostname || 'renogy.com';
              const copy = getLocationBlockedCopy(root);
              const replaceHost = (text) =>
                String(text || '').replace(/\{host\}/gi, host);
              const title = copy.title;
              const body1 = replaceHost(copy.body1);
              const body2 = copy.body2;
              const confirmText = copy.confirm;

              const dialogOptions = {
                title,
                html: `<p>${escapeHtml(body1)}</p><p>${escapeHtml(body2)}</p>`,
                confirmButtonText: confirmText,
                customClass: {
                  container: 'of-locator-location-blocked-swal',
                  title: 'of-locator-location-blocked-swal__title',
                  htmlContainer: 'of-locator-location-blocked-swal__body',
                  confirmButton: 'of-locator-location-blocked-swal__confirm',
                },
              };

              if (window.Swal?.fire) {
                window.Swal.fire(dialogOptions);
              } else {
                window.alert(`${title}\n\n${body1}\n${body2}`);
              }
            };

            showLocationBlockedDialog();
            return;
          }

          ensureMapReady().then(() => {
            if (!map) {
              initMap('init', { useGeolocation: true });
              return;
            }

            ensureDefaultLatLng().then((fallbackLatLng) => {
              useMyLocation('init', fallbackLatLng);
            });
          });
        });
      }

      root.addEventListener('click', (event) => {
        const businessName = event.target.closest('.bussiness-name');
        if (businessName && panelContainer.contains(businessName)) {
          const el = businessName.closest('.panel-item');
          if (!el) return;
          const item = parsePanelItemData(
            businessName.getAttribute('data-item') || el.getAttribute('data-item')
          );
          if (item) renderBusinessDetail(item);
          return;
        }

        if (event.target.closest('.back-header')) {
          handleBackHeader();
        }

        const phoneLink = event.target.closest('[data-of-locator-phone]');
        if (phoneLink && panelContainer.contains(phoneLink) && isLocatorDesktop()) {
          event.preventDefault();
          copyLocatorPhone(phoneLink.dataset.ofLocatorPhone, phoneLink);
          return;
        }

        const accordionTrigger = event.target.closest('.detail-accordion__trigger');
        if (accordionTrigger && panelContainer.contains(accordionTrigger)) {
          toggleDetailAccordion(accordionTrigger.closest('.detail-accordion'));
          return;
        }

        const addressDirections = event.target.closest('[data-of-locator-directions]');
        if (addressDirections && panelContainer.contains(addressDirections)) {
          event.preventDefault();
          const panelItem = addressDirections.closest('.panel-item');
          openLocatorDirections(
            parsePanelItemData(panelItem?.getAttribute('data-item'))
          );
          return;
        }

        const directions = event.target.closest('.directions-item');
        if (directions) {
          event.preventDefault();
          openLocatorDirections(
            parsePanelItemData(directions.getAttribute('data-location'))
          );
        }
      });

      panelContainer.addEventListener('mouseover', (event) => {
        if (!isLocatorDesktop() || !map) return;

        const el = event.target.closest('.panel-item');
        if (!el || !panelContainer.contains(el)) return;
        const item = parsePanelItemData(el.getAttribute('data-item'));
        if (!item?.id) return;

        const marker = markers[item.id];
        if (!marker) return;

        if (activeInfoId && infowindows[activeInfoId]) {
          infowindows[activeInfoId].close();
        }

        const hoverCenter = parseLatLng(item.latitude, item.longitude);
        if (hoverCenter) {
          map.setCenter(hoverCenter);
        }

        if (!SHOW_BUSINESS_INFO_WINDOW) {
          activeInfoId = item.id;
          return;
        }

        const name = el.getAttribute('data-name');
        const infowindow = new google.maps.InfoWindow({
          content: buildBusinessInfoHtml(name, item.distance, item),
          ariaLabel: name,
        });
        infowindow.open({ anchor: marker, map });
        infowindows[item.id] = infowindow;
        activeInfoId = item.id;
      });

      panelContainer.addEventListener('mouseout', (event) => {
        if (!isLocatorDesktop() || !map) return;

        const el = event.target.closest('.panel-item');
        if (!el || !panelContainer.contains(el)) return;

        const related = event.relatedTarget;
        if (related instanceof Node && el.contains(related)) return;

        const item = parsePanelItemData(el.getAttribute('data-item'));
        if (!item?.id) return;

        if (infowindows[item.id]) infowindows[item.id].close();
        if (activeInfoId === item.id) activeInfoId = null;

        if (hasActivePosition()) {
          map.setCenter(pos);
        }
      });
    }

    loadGoogleMaps().then(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || !isLocatorTabPanelActive()) return;
          activateLocatorIfNeeded();
          if (mapVisibilityObserver) {
            mapVisibilityObserver.unobserve(entry.target);
          }
        });
      });
      mapVisibilityObserver = observer;
      observer.observe(root);

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          refreshMapLayout(getMapLayoutCenter());
        });
        resizeObserver.observe(mapContainer);
        resizeObserver.observe(root);
      }
    });

    bindTabActivationListener();

    bindEvents();
    root.dataset.ofLocatorInitialized = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-installer-locator]').forEach(initLocator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
